(function () {
  'use strict';

  var RUNTIME_VERSION = '4.11.2-promotional-classics-2';
  var MAP_FILE = 'vcc-search-route-map-v4.json';
  var EXCLUDED_FILTER = 'system:exclude-search';
  var RUNTIME_SCRIPT_URL = document.currentScript && document.currentScript.src
    ? document.currentScript.src
    : '';
  var MODIFIER_KINDS = new Set([
    'type', 'subtype', 'size', 'color', 'pattern', 'era', 'year', 'feature'
  ]);
  var SECONDARY_ENTITY_KINDS = new Set([
    'team', 'franchise', 'brand', 'subject', 'person', 'event', 'league', 'sport'
  ]);
  var GROUP_CONTEXT_KINDS = new Set([
    'league', 'sport', 'market', 'region', 'country', 'location'
  ]);
  var APPAREL_CONTEXT_ENTITY_KINDS = new Set([
    'team', 'franchise', 'brand', 'subject', 'person', 'event',
    'family', 'collection', 'topic', 'league', 'sport', 'market',
    'region', 'country', 'location'
  ]);
  var CONSERVATIVE_FUZZY_BRAND_TARGETS = new Set([
    'brand:adidas', 'brand:champion', 'brand:ellesse', 'brand:fila',
    'brand:guess', 'brand:harley-davidson', 'brand:nike', 'brand:reebok',
    'brand:starter', 'brand:tommy-hilfiger'
  ]);
  var PROMOTIONAL_CLASSICS_COLLECTION_TARGETS = new Set([
    'collection:beer-booze', 'collection:tobacco'
  ]);
  var CLASSICS_QUERY_CANONICAL_PHRASES = new Map([
    ['cats', 'cat'],
    ['kittens', 'kitten'],
    ['puppy', 'dog'],
    ['puppies', 'dog'],
    ['animal', 'animals'],
    ['tv show', 'tv'],
    ['tv shows', 'tv'],
    ['comic book', 'comics'],
    ['comic books', 'comics'],
    ['superheroes', 'superhero'],
    ['beers', 'beer'],
    ['budweisers', 'budweiser'],
    ['camels', 'camel'],
    ['marlboros', 'marlboro'],
    ['molsons', 'molson'],
    ['miller lites', 'miller lite'],
    ['miller genuine drafts', 'miller genuine draft'],
    ['bud lights', 'bud light'],
    ['heinekens', 'heineken'],
    ['labatt blues', 'labatt blue'],
    ['pilsners', 'pilsner'],
    ['crystal lagers', 'crystal lager'],
    ['kokanees', 'kokanee'],
    ['coronas', 'corona'],
    ['jagermeisters', 'jagermeister'],
    ['berentzens', 'berentzen'],
    ['hobgoblin cafes', 'hobgoblin cafe'],
    ['skoals', 'skoal'],
    ['restaurants', 'restaurant'],
    ['winnie pooh', 'winnie the pooh']
  ]);
  var CONSERVATIVE_FUZZY_CLASSICS_KINDS = new Set([
    'subject', 'person', 'event'
  ]);
  var PRIMARY_KIND_PRIORITY = new Map([
    ['team', 100],
    ['franchise', 95],
    ['brand', 90],
    ['subject', 85],
    ['person', 84],
    ['event', 83],
    ['league', 82],
    ['sport', 81],
    ['family', 80],
    ['market', 76],
    ['region', 75],
    ['country', 74],
    ['location', 73],
    ['collection', 70],
    ['topic', 60]
  ]);
  var PRODUCT_PRIMARY_KIND_PRIORITY = new Map([
    ['team', 120],
    ['franchise', 115],
    ['person', 110],
    ['event', 108],
    ['subject', 105],
    ['family', 95],
    ['topic', 90],
    ['brand', 85],
    ['league', 75],
    ['sport', 74],
    ['collection', 65],
    ['market', 55],
    ['region', 54],
    ['country', 53],
    ['location', 52]
  ]);
  var PRODUCT_CONTEXT_MODIFIER_KINDS = new Set(['type']);

  var runtime = null;
  var resolver = null;
  var runtimePromise = null;
  var runtimeFailure = null;
  var config = readConfig();

  function own(object, key) {
    return Object.prototype.hasOwnProperty.call(object, key);
  }

  function normalizeQuery(value) {
    var normalized = String(value == null ? '' : value);
    try {
      normalized = normalized.normalize('NFKD');
    } catch (_error) {}
    return normalized
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[\u2018\u2019\u201b']/g, ' ')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim()
      .replace(/\s+/g, ' ')
      .replace(/\bt shirts\b/g, 't shirt')
      .replace(/\btshirts\b/g, 'tshirt');
  }

  function unique(values) {
    var seen = new Set();
    return (values || []).map(function (value) {
      return String(value || '').trim();
    }).filter(function (value) {
      if (!value || seen.has(value)) return false;
      seen.add(value);
      return true;
    });
  }

  function readConfig() {
    var inline = {};
    try {
      var node = document.querySelector('[data-vcc-search-v4-config]');
      if (node && String(node.textContent || '').trim()) {
        inline = JSON.parse(node.textContent);
      }
    } catch (_error) {}

    var supplied = window.VCCSearchV4Config;
    if (!supplied || typeof supplied !== 'object') supplied = {};
    var merged = Object.assign({}, inline, supplied);
    var script = document.currentScript;
    var base = script && script.src ? script.src : document.baseURI;
    if (!merged.routeMapUrl && base) {
      try {
        merged.routeMapUrl = new URL(MAP_FILE, base).href;
      } catch (_error) {}
    }
    merged.filterParameter = String(
      merged.filterParameter || 'filter.p.m.vcc_search.index'
    );
    merged.filterLogic = String(merged.filterLogic || 'AND').trim().toUpperCase();
    return merged;
  }

  function invariant(condition, message) {
    if (!condition) throw new Error(message);
  }

  function diagnosticMarkers() {
    return Array.prototype.slice.call(
      document.querySelectorAll('[data-vcc-search-marker]')
    );
  }

  function updateDiagnosticMarkers(values) {
    diagnosticMarkers().forEach(function (marker) {
      Object.keys(values || {}).forEach(function (name) {
        var value = String(values[name] || '').trim();
        if (value) marker.setAttribute(name, value);
      });
      marker.setAttribute('data-vcc-search-route-version', RUNTIME_VERSION);
      marker.setAttribute('data-vcc-search-runtime-version', RUNTIME_VERSION);
    });
  }

  function sha256Hex(text) {
    if (!window.crypto || !window.crypto.subtle || typeof TextEncoder !== 'function') {
      return Promise.resolve('');
    }
    return window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(String(text || '')))
      .then(function (buffer) {
        return Array.prototype.map.call(new Uint8Array(buffer), function (value) {
          return value.toString(16).padStart(2, '0');
        }).join('').toUpperCase();
      }).catch(function () { return ''; });
  }

  function updateSearchBuildMarker() {
    updateDiagnosticMarkers({});
    if (!RUNTIME_SCRIPT_URL) return;
    var storageKey = 'vcc-search-build-sha256::' + RUNTIME_SCRIPT_URL;
    try {
      var cached = window.sessionStorage.getItem(storageKey) || '';
      if (/^[A-F0-9]{64}$/.test(cached)) {
        updateDiagnosticMarkers({ 'data-vcc-search-build': cached });
        return;
      }
    } catch (_error) {}
    fetch(RUNTIME_SCRIPT_URL, { credentials: 'same-origin', cache: 'force-cache' })
      .then(function (response) {
        if (!response || !response.ok) return '';
        return response.text();
      })
      .then(sha256Hex)
      .then(function (hash) {
        if (!hash) return;
        try { window.sessionStorage.setItem(storageKey, hash); } catch (_error) {}
        updateDiagnosticMarkers({ 'data-vcc-search-build': hash });
      }).catch(function () {});
  }

  function validateRuntime(candidate) {
    invariant(candidate && typeof candidate === 'object', 'Invalid route map');
    invariant(candidate.version === RUNTIME_VERSION, 'Unexpected route-map version');
    invariant(Number(candidate.schema_version) === 2, 'Unexpected route-map schema version');
    invariant(candidate.filterLogic === 'AND', 'Route-map storefront filter logic must be AND');
    invariant(config.filterLogic === 'AND', 'Theme storefront filter logic must be AND');
    invariant(
      candidate.filterLogic === config.filterLogic,
      'Route-map filter logic does not match theme configuration'
    );
    invariant(candidate.metafield && candidate.metafield.namespace === 'vcc_search', 'Invalid metafield namespace');
    invariant(candidate.metafield.key === 'index', 'Invalid metafield key');
    invariant(candidate.metafield.type === 'list.single_line_text_field', 'Invalid metafield type');
    invariant(
      candidate.metafield.filter_parameter === config.filterParameter,
      'Route-map filter parameter does not match theme configuration'
    );
    invariant(candidate.concepts && typeof candidate.concepts === 'object', 'Missing concepts');
    invariant(candidate.aliases && typeof candidate.aliases === 'object', 'Missing aliases');
    invariant(candidate.ambiguities && typeof candidate.ambiguities === 'object', 'Missing ambiguities');
    invariant(candidate.roots && candidate.templates && candidate.family_routes, 'Missing route metadata');
    var generatedStats = candidate.generated_stats;
    invariant(generatedStats && typeof generatedStats === 'object', 'Missing generated route-map stats');
    [
      ['concept_count', candidate.concepts],
      ['alias_count', candidate.aliases],
      ['ambiguity_count', candidate.ambiguities],
      ['manual_typo_alias_count', candidate.manual_typo_aliases || {}]
    ].forEach(function (definition) {
      invariant(
        Number(generatedStats[definition[0]]) === Object.keys(definition[1]).length,
        'Generated route-map stat mismatch: ' + definition[0]
      );
    });
    invariant(
      candidate.integrity
      && candidate.integrity.algorithm === 'SHA-256'
      && candidate.integrity.canonicalization === 'vcc-json-c14n-v1'
      && candidate.integrity.scope === 'whole-map-excluding-integrity.route_map_hash'
      && /^[A-F0-9]{64}$/i.test(String(candidate.integrity.route_map_hash || '')),
      'Invalid route-map integrity metadata'
    );
    invariant(
      candidate.modifier_dependencies && typeof candidate.modifier_dependencies === 'object',
      'Missing modifier dependency contract'
    );
    invariant(!own(candidate.concepts, 'version:v4-10'), 'Retired version concept remains');
    invariant(
      candidate.aliases['yellow jackets']
      && candidate.aliases['yellow jackets'].d === 'team:georgia-tech-yellow-jackets'
      && candidate.aliases['yellow jackets'].p === 1,
      'Protected Yellow Jackets alias is missing'
    );

    var conceptKeys = new Set(Object.keys(candidate.concepts));
    var teamKeys = Object.keys(candidate.concepts).filter(function (target) {
      return candidate.concepts[target] && candidate.concepts[target].k === 'team';
    });
    invariant(
      Number(generatedStats.team_count) === teamKeys.length,
      'Generated route-map stat mismatch: team_count'
    );
    invariant(
      candidate.team_relationships && typeof candidate.team_relationships === 'object',
      'Missing ordered team relationships'
    );
    invariant(
      Object.keys(candidate.team_relationships).length === teamKeys.length,
      'Incomplete ordered team relationship coverage'
    );
    invariant(
      candidate.team_qualifiers && typeof candidate.team_qualifiers === 'object',
      'Missing team qualifiers'
    );
    invariant(
      Object.keys(candidate.team_qualifiers).length === teamKeys.length,
      'Incomplete team qualifier coverage'
    );
    invariant(
      candidate.team_lineages && typeof candidate.team_lineages === 'object',
      'Missing team franchise lineages'
    );
    invariant(
      Object.keys(candidate.team_lineages).length === teamKeys.length,
      'Incomplete team franchise lineage coverage'
    );
    invariant(
      Number(generatedStats.team_relationship_count) === teamKeys.length,
      'Generated route-map stat mismatch: team_relationship_count'
    );
    invariant(
      Number(generatedStats.modifier_dependency_count)
        === Object.keys(candidate.modifier_dependencies).length,
      'Generated route-map stat mismatch: modifier_dependency_count'
    );
    invariant(
      candidate.qualifier_contract
      && candidate.qualifier_contract.queryable_requires_concept === true
      && candidate.qualifier_contract.queryable_requires_positive_count === true
      && Array.isArray(candidate.qualifier_contract.metadata_only_qualifiers),
      'Invalid team qualifier contract'
    );
    var metadataOnlyQualifiers = unique(candidate.qualifier_contract.metadata_only_qualifiers);
    invariant(
      metadataOnlyQualifiers.length === candidate.qualifier_contract.metadata_only_qualifiers.length,
      'Duplicate metadata-only qualifier'
    );
    metadataOnlyQualifiers.forEach(function (qualifier) {
      var qualifierConcept = candidate.concepts[qualifier];
      invariant(
        !qualifierConcept || Number(qualifierConcept.n) <= 0,
        'Queryable qualifier marked metadata-only: ' + qualifier
      );
    });
    var qualifierReferences = teamKeys.reduce(function (values, target) {
      return values.concat(candidate.team_qualifiers[target] || []);
    }, []);
    var uniqueQualifiers = unique(qualifierReferences);
    var queryableQualifierReferenceCount = qualifierReferences.filter(function (qualifier) {
      return candidate.concepts[qualifier] && Number(candidate.concepts[qualifier].n) > 0;
    }).length;
    var actualMetadataOnlyQualifiers = unique(qualifierReferences.filter(function (qualifier) {
      return !candidate.concepts[qualifier] || Number(candidate.concepts[qualifier].n) <= 0;
    }));
    var declaredMetadataOnlySet = new Set(metadataOnlyQualifiers);
    invariant(
      actualMetadataOnlyQualifiers.length === metadataOnlyQualifiers.length
      && actualMetadataOnlyQualifiers.every(function (qualifier) {
        return declaredMetadataOnlySet.has(qualifier);
      }),
      'Metadata-only qualifier registry mismatch'
    );
    invariant(Number(generatedStats.team_qualifier_reference_count) === qualifierReferences.length,
      'Generated route-map stat mismatch: team_qualifier_reference_count');
    invariant(Number(generatedStats.unique_qualifier_count) === uniqueQualifiers.length,
      'Generated route-map stat mismatch: unique_qualifier_count');
    invariant(Number(generatedStats.queryable_qualifier_reference_count) === queryableQualifierReferenceCount,
      'Generated route-map stat mismatch: queryable_qualifier_reference_count');
    invariant(
      Number(generatedStats.metadata_only_qualifier_reference_count)
        === qualifierReferences.length - queryableQualifierReferenceCount,
      'Generated route-map stat mismatch: metadata_only_qualifier_reference_count'
    );
    invariant(Number(generatedStats.metadata_only_qualifier_count) === metadataOnlyQualifiers.length,
      'Generated route-map stat mismatch: metadata_only_qualifier_count');
    var relationshipEdgeCount = 0;
    var activeRelationshipEdgeCount = 0;
    var crossTierActiveRelationshipEdgeCount = 0;
    teamKeys.forEach(function (target) {
      var relationship = candidate.team_relationships[target];
      invariant(relationship && Array.isArray(relationship.m) && Array.isArray(relationship.r),
        'Invalid team relationship: ' + target);
      var peers = relationship.m.concat(relationship.r);
      invariant(peers.length === new Set(peers).size, 'Duplicate team relationship: ' + target);
      peers.forEach(function (peer) {
        invariant(peer !== target, 'Self team relationship: ' + target);
        invariant(
          conceptKeys.has(peer) && candidate.concepts[peer].k === 'team',
          'Invalid team relationship peer: ' + target + ' -> ' + peer
        );
      });
      invariant(Array.isArray(relationship.peers), 'Missing executable team peer proofs: ' + target);
      invariant(relationship.peers.length === peers.length, 'Incomplete team peer proofs: ' + target);
      var qualifiers = candidate.team_qualifiers[target];
      invariant(Array.isArray(qualifiers), 'Invalid team qualifiers: ' + target);
      invariant(qualifiers.length === new Set(qualifiers).size, 'Duplicate team qualifier: ' + target);
      qualifiers.forEach(function (qualifier) {
        invariant(
          /^(?:league|sport|market|region|country|location):[a-z0-9-]+$/.test(qualifier),
          'Invalid team qualifier: ' + target + ' -> ' + qualifier
        );
      });
      var routeGeography = new Set((candidate.concepts[target].r || []).reduce(function (values, group) {
        return values.concat(group.filters || [], group.any_filters || []);
      }, []).filter(function (filter) {
        return /^(?:market|region):/.test(String(filter || ''));
      }));
      relationship.peers.forEach(function (proof, peerIndex) {
        var peer = peers[peerIndex];
        var expectedRelationshipTier = peerIndex < relationship.m.length ? 'market' : 'region';
        invariant(proof && proof.team === peer, 'Team peer proof order mismatch: ' + target);
        invariant(
          proof.relationship_tier === expectedRelationshipTier,
          'Team peer proof tier mismatch: ' + target + ' -> ' + peer
        );
        invariant(
          /^(?:market|region):[a-z0-9-]+$/.test(String(proof.qualifier || '')),
          'Invalid team peer qualifier: ' + target + ' -> ' + peer
        );
        var qualifierTier = String(proof.qualifier).split(':')[0];
        invariant(proof.qualifier_tier === qualifierTier,
          'Team peer qualifier tier mismatch: ' + target + ' -> ' + peer);
        invariant(
          qualifiers.indexOf(proof.qualifier) !== -1
          && (candidate.team_qualifiers[peer] || []).indexOf(proof.qualifier) !== -1,
          'Unshared team peer qualifier: ' + target + ' -> ' + peer
        );
        var qualifierConcept = candidate.concepts[proof.qualifier];
        var queryable = Boolean(qualifierConcept && Number(qualifierConcept.n) > 0);
        var routeDeclared = routeGeography.has(proof.qualifier);
        invariant(proof.qualifier_status === (queryable ? 'queryable' : 'metadata-only'),
          'Team peer qualifier status mismatch: ' + target + ' -> ' + peer);
        invariant(proof.route_declared === routeDeclared,
          'Team peer route status mismatch: ' + target + ' -> ' + peer);
        invariant(proof.active === (queryable && routeDeclared),
          'Team peer active status mismatch: ' + target + ' -> ' + peer);
        invariant(
          proof.active === true
            ? proof.clause
              && Array.isArray(proof.clause.allOf)
              && proof.clause.allOf.length === 2
              && proof.clause.allOf[0] === peer
              && proof.clause.allOf[1] === proof.qualifier
            : proof.clause === null,
          'Invalid team peer proof clause: ' + target + ' -> ' + peer
        );
        relationshipEdgeCount += 1;
        if (proof.active === true) {
          activeRelationshipEdgeCount += 1;
          if (proof.relationship_tier !== proof.qualifier_tier) {
            crossTierActiveRelationshipEdgeCount += 1;
          }
        }
      });
      [['m', 'market:'], ['r', 'region:']].forEach(function (definition) {
        var relationshipKey = definition[0];
        var prefix = definition[1];
        var subjectLocations = new Set(qualifiers.filter(function (qualifier) {
          return String(qualifier || '').indexOf(prefix) === 0;
        }));
        relationship[relationshipKey].forEach(function (peer) {
          var peerLocations = candidate.team_qualifiers[peer] || [];
          invariant(
            peerLocations.some(function (qualifier) { return subjectLocations.has(qualifier); }),
            'Unattested team location peer: ' + target + ' -> ' + peer
          );
        });
      });
      var lineages = candidate.team_lineages[target];
      invariant(Array.isArray(lineages), 'Invalid team franchise lineages: ' + target);
      var lineageKeys = new Set();
      lineages.forEach(function (lineage) {
        invariant(
          lineage && lineage.id && lineage.label && Array.isArray(lineage.filters)
          && lineage.filters.length > 0,
          'Invalid team franchise lineage: ' + target
        );
        var lineageKey = lineage.id + '::' + lineage.filters.join('|');
        invariant(!lineageKeys.has(lineageKey), 'Duplicate team franchise lineage: ' + target);
        lineageKeys.add(lineageKey);
        lineage.filters.forEach(function (filter) {
          invariant(conceptKeys.has(filter), 'Invalid team franchise filter: ' + target + ' -> ' + filter);
          invariant(
            ['team', 'franchise'].includes(candidate.concepts[filter].k),
            'Unsafe team franchise filter kind: ' + target + ' -> ' + filter
          );
        });
      });
    });
    invariant(
      Number(generatedStats.relationship_edge_count) === relationshipEdgeCount,
      'Generated route-map stat mismatch: relationship_edge_count'
    );
    invariant(
      Number(generatedStats.active_relationship_edge_count) === activeRelationshipEdgeCount,
      'Generated route-map stat mismatch: active_relationship_edge_count'
    );
    invariant(
      Number(generatedStats.inactive_relationship_edge_count)
        === relationshipEdgeCount - activeRelationshipEdgeCount,
      'Generated route-map stat mismatch: inactive_relationship_edge_count'
    );
    invariant(
      Number(generatedStats.cross_tier_active_relationship_edge_count)
        === crossTierActiveRelationshipEdgeCount,
      'Generated route-map stat mismatch: cross_tier_active_relationship_edge_count'
    );
    invariant(
      candidate.team_relationship_policy
      && candidate.team_relationship_policy.raw_region_filters === 'route-declared-only',
      'Unsafe team region policy'
    );
    invariant(
      candidate.team_relationship_policy.peer_attestation === 'team-and-shared-location-token',
      'Unsafe team peer attestation policy'
    );
    Object.entries(candidate.aliases).forEach(function (entry) {
      var alias = entry[0];
      var definition = entry[1];
      invariant(definition && conceptKeys.has(definition.d), 'Invalid alias default: ' + alias);
      (definition.t || []).forEach(function (target) {
        invariant(Array.isArray(target) && conceptKeys.has(target[0]), 'Invalid alias target: ' + alias);
      });
    });
    Object.entries(candidate.ambiguities).forEach(function (entry) {
      var alias = entry[0];
      var definition = entry[1];
      invariant(definition && definition.d !== 'GROUP', 'Unresolved ambiguity: ' + alias);
      invariant(conceptKeys.has(definition.d), 'Invalid ambiguity default: ' + alias);
      (definition.c || []).forEach(function (target) {
        invariant(conceptKeys.has(target), 'Invalid ambiguity target: ' + alias);
      });
    });
    Object.entries(candidate.manual_typo_aliases || {}).forEach(function (entry) {
      invariant(conceptKeys.has(entry[1]), 'Invalid typo target: ' + entry[0]);
    });
    Object.entries(candidate.concepts).forEach(function (entry) {
      var value = entry[0];
      var concept = entry[1];
      invariant(concept && concept.l && concept.k && concept.t, 'Invalid concept: ' + value);
      (concept.r || []).forEach(function (group) {
        (group.filters || []).concat(group.any_filters || []).forEach(function (filter) {
          invariant(conceptKeys.has(filter), 'Invalid route filter: ' + filter);
        });
      });
    });
    Object.entries(candidate.modifier_dependencies).forEach(function (entry) {
      var value = entry[0];
      var dependencies = entry[1];
      invariant(conceptKeys.has(value), 'Invalid modifier dependency source: ' + value);
      invariant(Array.isArray(dependencies) && dependencies.length > 0,
        'Invalid modifier dependencies: ' + value);
      invariant(unique(dependencies).length === dependencies.length,
        'Duplicate modifier dependency: ' + value);
      dependencies.forEach(function (requiredTarget) {
        invariant(requiredTarget !== value, 'Self-dependent modifier concept: ' + value);
        invariant(conceptKeys.has(requiredTarget),
          'Invalid modifier dependency: ' + value + ' -> ' + requiredTarget);
        invariant(
          MODIFIER_KINDS.has(candidate.concepts[value].k)
          && MODIFIER_KINDS.has(candidate.concepts[requiredTarget].k),
          'Unsafe modifier dependency: ' + value + ' -> ' + requiredTarget
        );
      });
    });
    ['teamwear', 'brands', 'vintage-classics'].forEach(function (rootKey) {
      var root = candidate.roots[rootKey];
      invariant(root && conceptKeys.has(root.filter), 'Invalid root: ' + rootKey);
      invariant(/^\/collections\/[a-z0-9-]+$/.test(root.collection_url), 'Invalid root destination: ' + rootKey);
    });
    return candidate;
  }

  function loadRuntime() {
    if (runtime) return Promise.resolve(runtime);
    if (runtimePromise) return runtimePromise;
    if (!config.routeMapUrl) {
      runtimeFailure = new Error('Missing route-map URL');
      runtimePromise = Promise.reject(runtimeFailure);
      return runtimePromise;
    }
    runtimePromise = fetch(config.routeMapUrl, {
      credentials: 'same-origin',
      cache: 'force-cache'
    }).then(function (response) {
      if (!response || !response.ok) throw new Error('Route map unavailable');
      return response.text();
    }).then(function (routeText) {
      var candidate = JSON.parse(routeText);
      sha256Hex(routeText).then(function (hash) {
        updateDiagnosticMarkers({
          'data-vcc-search-route-version': candidate.version,
          'data-vcc-search-route-sha256': hash
        });
      });
      runtime = validateRuntime(candidate);
      resolver = createResolver(runtime);
      return runtime;
    }).catch(function (error) {
      runtimeFailure = error;
      throw error;
    });
    return runtimePromise;
  }

  function aliasPriority(definition, target) {
    var targets = definition.t || [];
    var matched = targets.find(function (candidate) {
      return candidate[0] === target;
    });
    if (matched) return Number(matched[1]) || 0;
    return Math.max.apply(Math, [0].concat(targets.map(function (candidate) {
      return Number(candidate[1]) || 0;
    })));
  }

  function createAliasRecord(sourcePhrase, definition, target, secondary, map) {
    var phrase = normalizeQuery(sourcePhrase);
    var concept = map.concepts[target];
    if (!phrase || !concept) return null;
    var authoritativeTeamPhrase = ['team', 'franchise'].includes(concept.k)
      && ['sports-team', 'sports-franchise'].includes(String(concept.t || '').replace(/_/g, '-'))
      && phrase.split(' ').length > 1;
    var declaredTarget = (definition.t || []).find(function (candidate) {
      return candidate[0] === target;
    });
    return {
      phrase: phrase,
      tokens: phrase.split(' '),
      target: target,
      kind: concept.k,
      template: concept.t,
      protected: definition.p === 1 || authoritativeTeamPhrase,
      priority: aliasPriority(definition, target),
      count: Number(declaredTarget && declaredTarget[2]) || Number(concept.n) || 0,
      resolution: definition.r || 'highest-priority',
      secondary: secondary === true
    };
  }

  function buildAliasIndex(map) {
    var byFirstToken = new Map();
    var declaredPhrases = new Set();
    function add(record) {
      if (!record) return;
      var first = record.tokens[0];
      if (!byFirstToken.has(first)) byFirstToken.set(first, []);
      byFirstToken.get(first).push(record);
    }

    Object.entries(map.aliases).forEach(function (entry) {
      var sourcePhrase = entry[0];
      var definition = entry[1];
      var normalized = normalizeQuery(sourcePhrase);
      var ambiguity = map.ambiguities[normalized];
      var defaultTarget = ambiguity && map.concepts[ambiguity.d]
        ? ambiguity.d
        : definition.d;
      add(createAliasRecord(sourcePhrase, definition, defaultTarget, false, map));
      (definition.t || []).forEach(function (targetDefinition) {
        var target = targetDefinition[0];
        if (target !== defaultTarget) {
          add(createAliasRecord(sourcePhrase, definition, target, true, map));
        }
      });
      declaredPhrases.add(normalized);
    });

    Object.entries(map.manual_typo_aliases || {}).forEach(function (entry) {
      var sourcePhrase = entry[0];
      var target = entry[1];
      var normalized = normalizeQuery(sourcePhrase);
      if (!normalized || declaredPhrases.has(normalized)) return;
      add(createAliasRecord(sourcePhrase, {
        d: target,
        t: [[target, 120, Number(map.concepts[target] && map.concepts[target].n) || 0]],
        p: 1,
        r: 'manual-typo'
      }, target, false, map));
    });

    byFirstToken.forEach(function (bucket) {
      bucket.sort(primaryMatchOrder);
    });
    return byFirstToken;
  }

  function oneConservativeTypoApart(leftValue, rightValue) {
    var left = String(leftValue || '');
    var right = String(rightValue || '');
    if (left === right) return 0;
    if (
      left.length < 3
      || right.length < 3
      || left.charAt(0) !== right.charAt(0)
      || Math.abs(left.length - right.length) > 1
      || (
        left.length !== right.length
        && left.charAt(left.length - 1) !== right.charAt(right.length - 1)
      )
    ) return 2;

    if (left.length === right.length) {
      var mismatches = [];
      for (var index = 0; index < left.length; index += 1) {
        if (left.charAt(index) !== right.charAt(index)) mismatches.push(index);
        if (mismatches.length > 2) return 2;
      }
      if (mismatches.length === 1) return 1;
      if (
        mismatches.length === 2
        && mismatches[1] === mismatches[0] + 1
        && left.charAt(mismatches[0]) === right.charAt(mismatches[1])
        && left.charAt(mismatches[1]) === right.charAt(mismatches[0])
      ) return 1;
      return 2;
    }

    var shorter = left.length < right.length ? left : right;
    var longer = left.length < right.length ? right : left;
    var shortIndex = 0;
    var longIndex = 0;
    var skipped = false;
    while (shortIndex < shorter.length && longIndex < longer.length) {
      if (shorter.charAt(shortIndex) === longer.charAt(longIndex)) {
        shortIndex += 1;
        longIndex += 1;
      } else {
        if (skipped) return 2;
        skipped = true;
        longIndex += 1;
      }
    }
    return 1;
  }

  function buildConservativeBrandTypoRecords(map) {
    var records = [];
    var seen = new Set();
    Object.entries(map.aliases || {}).forEach(function (entry) {
      var sourcePhrase = entry[0];
      var definition = entry[1];
      var normalized = normalizeQuery(sourcePhrase);
      var ambiguity = map.ambiguities[normalized];
      var target = ambiguity && map.concepts[ambiguity.d]
        ? ambiguity.d
        : definition.d;
      if (
        !CONSERVATIVE_FUZZY_BRAND_TARGETS.has(target)
        || !map.concepts[target]
        || map.concepts[target].k !== 'brand'
      ) return;
      var record = createAliasRecord(sourcePhrase, definition, target, false, map);
      if (
        !record
        || record.tokens.some(function (token) { return token.length < 4; })
      ) return;
      var key = record.phrase + '|' + record.target;
      if (seen.has(key)) return;
      seen.add(key);
      records.push(record);
    });
    return records.sort(primaryMatchOrder);
  }

  function buildConservativeClassicsTypoRecords(map) {
    var records = [];
    var seen = new Set();
    Object.entries(map.aliases || {}).forEach(function (entry) {
      var sourcePhrase = entry[0];
      var definition = entry[1];
      var targets = unique([definition.d].concat((definition.t || []).map(function (target) {
        return target[0];
      })));
      targets.forEach(function (target) {
        var concept = map.concepts[target];
        if (
          !concept
          || !CONSERVATIVE_FUZZY_CLASSICS_KINDS.has(concept.k)
          || !conceptRoutesToRoot(map, target, 'root:vintage-classics')
        ) return;
        var record = createAliasRecord(sourcePhrase, definition, target, false, map);
        if (
          !record
          || record.tokens.some(function (token) { return token.length < 4; })
        ) return;
        var key = record.phrase + '|' + record.target;
        if (seen.has(key)) return;
        seen.add(key);
        record.protected = true;
        record.priority = Math.max(135, Number(record.priority) || 0);
        records.push(record);
      });
    });
    return records.sort(primaryMatchOrder);
  }

  function collectConservativeBrandTypoMatches(tokens, records, exactMatches) {
    var hasModifierContext = exactMatches.some(function (match) {
      return MODIFIER_KINDS.has(match.kind);
    });
    var candidates = [];
    records.forEach(function (record) {
      for (var start = 0; start + record.tokens.length <= tokens.length; start += 1) {
        var totalDistance = 0;
        for (var offset = 0; offset < record.tokens.length; offset += 1) {
          totalDistance += oneConservativeTypoApart(
            tokens[start + offset],
            record.tokens[offset]
          );
          if (totalDistance > 1) break;
        }
        if (totalDistance !== 1) continue;
        var end = start + record.tokens.length;
        var overlapsDeclaredPrimary = exactMatches.some(function (match) {
          return match.secondary !== true
            && PRIMARY_KIND_PRIORITY.has(match.kind)
            && match.start === start
            && match.end === end;
        });
        if (overlapsDeclaredPrimary) continue;
        var overlapsExactModifier = exactMatches.some(function (match) {
          return MODIFIER_KINDS.has(match.kind)
            && start < match.end
            && match.start < end;
        });
        if (overlapsExactModifier) continue;
        if (!hasModifierContext && (start !== 0 || record.tokens.length !== tokens.length)) {
          continue;
        }
        candidates.push(Object.assign({}, record, {
          start: start,
          end: end,
          resolution: 'conservative-brand-typo',
          secondary: false
        }));
      }
    });

    var bySpan = new Map();
    candidates.forEach(function (candidate) {
      var key = candidate.start + ':' + candidate.end;
      if (!bySpan.has(key)) bySpan.set(key, []);
      bySpan.get(key).push(candidate);
    });
    var selected = [];
    bySpan.forEach(function (spanCandidates) {
      var targets = unique(spanCandidates.map(function (candidate) {
        return candidate.target;
      }));
      if (targets.length !== 1) return;
      spanCandidates.sort(primaryMatchOrder);
      selected.push(spanCandidates[0]);
    });
    return selected;
  }

  function collectConservativeClassicsTypoMatches(tokens, records, exactMatches) {
    var hasModifierContext = exactMatches.some(function (match) {
      return MODIFIER_KINDS.has(match.kind);
    });
    var candidates = [];
    records.forEach(function (record) {
      for (var start = 0; start + record.tokens.length <= tokens.length; start += 1) {
        var totalDistance = 0;
        for (var offset = 0; offset < record.tokens.length; offset += 1) {
          totalDistance += oneConservativeTypoApart(
            tokens[start + offset],
            record.tokens[offset]
          );
          if (totalDistance > 1) break;
        }
        if (totalDistance !== 1) continue;
        var end = start + record.tokens.length;
        var overlapsDeclaredPrimary = exactMatches.some(function (match) {
          return match.secondary !== true
            && PRIMARY_KIND_PRIORITY.has(match.kind)
            && match.start === start
            && match.end === end;
        });
        if (overlapsDeclaredPrimary) continue;
        var overlapsExactModifier = exactMatches.some(function (match) {
          return MODIFIER_KINDS.has(match.kind)
            && start < match.end
            && match.start < end;
        });
        if (overlapsExactModifier) continue;
        if (!hasModifierContext && (start !== 0 || record.tokens.length !== tokens.length)) {
          continue;
        }
        candidates.push(Object.assign({}, record, {
          start: start,
          end: end,
          resolution: 'conservative-classics-typo',
          secondary: false,
          protected: true
        }));
      }
    });

    var bySpan = new Map();
    candidates.forEach(function (candidate) {
      var key = candidate.start + ':' + candidate.end;
      if (!bySpan.has(key)) bySpan.set(key, []);
      bySpan.get(key).push(candidate);
    });
    var selected = [];
    bySpan.forEach(function (spanCandidates) {
      var targets = unique(spanCandidates.map(function (candidate) {
        return candidate.target;
      }));
      if (targets.length !== 1) return;
      spanCandidates.sort(primaryMatchOrder);
      selected.push(spanCandidates[0]);
    });
    return selected;
  }

  function collectCanonicalClassicsMatches(tokens, aliasIndex, map, exactMatches) {
    var matches = [];
    var seen = new Set();
    var explicitBrandsContext = (exactMatches || []).some(function (match) {
      return match.target === 'root:brands';
    });
    if (explicitBrandsContext) return matches;
    CLASSICS_QUERY_CANONICAL_PHRASES.forEach(function (canonicalPhrase, sourcePhrase) {
      var sourceTokens = sourcePhrase.split(' ');
      var canonicalTokens = canonicalPhrase.split(' ');
      for (var start = 0; start + sourceTokens.length <= tokens.length; start += 1) {
        if (!sourceTokens.every(function (token, offset) {
          return tokens[start + offset] === token;
        })) continue;
        var end = start + sourceTokens.length;
        var containedByLongerPrimary = (exactMatches || []).some(function (match) {
          return PRIMARY_KIND_PRIORITY.has(match.kind)
            && match.start <= start
            && match.end >= end
            && (match.start < start || match.end > end);
        });
        if (containedByLongerPrimary) continue;
        var sameSpanTeam = (exactMatches || []).some(function (match) {
          return ['team', 'franchise'].includes(match.kind)
            && match.start === start
            && match.end === end;
        });
        var hasTeamQualifier = (exactMatches || []).some(function (match) {
          return GROUP_CONTEXT_KINDS.has(match.kind)
            && (match.end <= start || match.start >= end);
        });
        if (sameSpanTeam && hasTeamQualifier) continue;
        var bucket = aliasIndex.get(canonicalTokens[0]) || [];
        bucket.forEach(function (record) {
          if (
            record.tokens.length !== canonicalTokens.length
            || !record.tokens.every(function (token, offset) {
              return token === canonicalTokens[offset];
            })
            || !['subject', 'family', 'topic'].includes(record.kind)
            || !conceptRoutesToRoot(map, record.target, 'root:vintage-classics')
          ) return;
          var key = start + ':' + end + ':' + record.target;
          if (seen.has(key)) return;
          seen.add(key);
          matches.push(Object.assign({}, record, {
            phrase: sourcePhrase,
            tokens: sourceTokens.slice(),
            start: start,
            end: end,
            protected: true,
            priority: Math.max(140, Number(record.priority) || 0),
            resolution: 'classics-morphology',
            secondary: false
          }));
        });
      }
    });
    return matches;
  }

  function collectMatches(tokens, aliasIndex) {
    var matches = [];
    for (var start = 0; start < tokens.length; start += 1) {
      var bucket = aliasIndex.get(tokens[start]) || [];
      bucket.forEach(function (record) {
        if (start + record.tokens.length > tokens.length) return;
        for (var offset = 0; offset < record.tokens.length; offset += 1) {
          if (tokens[start + offset] !== record.tokens[offset]) return;
        }
        matches.push(Object.assign({}, record, {
          start: start,
          end: start + record.tokens.length
        }));
      });
    }
    return matches;
  }

  function primaryMatchOrder(left, right) {
    return right.tokens.length - left.tokens.length
      || Number(right.protected) - Number(left.protected)
      || Number(left.secondary) - Number(right.secondary)
      || right.priority - left.priority
      || (PRIMARY_KIND_PRIORITY.get(right.kind) || 0) - (PRIMARY_KIND_PRIORITY.get(left.kind) || 0)
      || left.start - right.start
      || left.phrase.localeCompare(right.phrase);
  }

  function modifierMatchOrder(left, right) {
    return right.tokens.length - left.tokens.length
      || Number(right.protected) - Number(left.protected)
      || right.priority - left.priority
      || left.start - right.start
      || left.phrase.localeCompare(right.phrase);
  }

  function overlaps(left, right) {
    return left.start < right.end && right.start < left.end;
  }

  function conceptRoutesToRoot(map, target, rootTarget) {
    var concept = map && map.concepts && map.concepts[target];
    if (!concept) return false;
    return (concept.r || []).some(function (group) {
      return unique((group.filters || []).concat(group.any_filters || []))
        .indexOf(rootTarget) !== -1;
    });
  }

  function conceptRoutesToPromotionalClassics(map, target) {
    if (PROMOTIONAL_CLASSICS_COLLECTION_TARGETS.has(target)) return true;
    var concept = map && map.concepts && map.concepts[target];
    if (!concept) return false;
    return (concept.r || []).some(function (group) {
      return unique((group.filters || []).concat(group.any_filters || []))
        .some(function (filter) {
          return PROMOTIONAL_CLASSICS_COLLECTION_TARGETS.has(filter);
        });
    });
  }

  function preferPromotionalClassicsIdentity(primary, primaryCandidates, map) {
    var promotionalCandidates = (primaryCandidates || []).filter(function (candidate) {
      return ['subject', 'topic', 'collection'].includes(candidate.kind)
        && conceptRoutesToPromotionalClassics(map, candidate.target);
    });
    if (!promotionalCandidates.length) return primary;

    var kindPriority = new Map([
      ['subject', 30],
      ['topic', 20],
      ['collection', 10]
    ]);
    promotionalCandidates.sort(function (left, right) {
      return right.tokens.length - left.tokens.length
        || Number(right.protected) - Number(left.protected)
        || (kindPriority.get(right.kind) || 0) - (kindPriority.get(left.kind) || 0)
        || right.priority - left.priority
        || left.start - right.start
        || left.target.localeCompare(right.target);
    });
    var preferred = promotionalCandidates[0];

    // Preserve a longer protected identity that fully contains the promotional
    // token, such as "Winston Salem", "H L Miller", or "Miller brand".
    if (
      primary
      && !conceptRoutesToPromotionalClassics(map, primary.target)
      && primary.protected === true
      && primary.tokens.length > preferred.tokens.length
      && primary.start <= preferred.start
      && primary.end >= preferred.end
    ) return primary;

    return Object.assign({}, preferred, {
      secondary: false,
      resolution: 'promotional-classics-authoritative'
    });
  }

  function specificVintageClassicsCollision(primary, primaryCandidates, matches, map) {
    if (
      primary
      && ['team', 'franchise'].includes(primary.kind)
    ) return null;
    if ((matches || []).some(function (match) {
      return match.target === 'root:brands';
    })) return null;

    var choices = [];
    (primaryCandidates || []).forEach(function (candidate) {
      if (
        candidate.kind !== 'subject'
        || String(candidate.resolution || '').indexOf('context-required') === -1
        || !conceptRoutesToRoot(map, candidate.target, 'root:vintage-classics')
      ) return;
      var collisionBrands = (primaryCandidates || []).filter(function (brandCandidate) {
        return brandCandidate.kind === 'brand'
          && brandCandidate.start === candidate.start
          && brandCandidate.end === candidate.end
          && String(brandCandidate.resolution || '').indexOf('context-required') !== -1;
      });
      if (!collisionBrands.length) return;
      var classicCount = Math.max(0, Number(candidate.count) || 0);
      choices.push({
        candidate: candidate,
        collisionBrands: collisionBrands,
        classicCount: classicCount
      });
    });
    choices.sort(function (left, right) {
      return right.candidate.tokens.length - left.candidate.tokens.length
        || right.candidate.priority - left.candidate.priority
        || (PRIMARY_KIND_PRIORITY.get(right.candidate.kind) || 0)
          - (PRIMARY_KIND_PRIORITY.get(left.candidate.kind) || 0)
        || right.classicCount - left.classicCount
        || left.candidate.start - right.candidate.start
        || left.candidate.target.localeCompare(right.candidate.target);
    });
    if (!choices.length) return null;
    return {
      primary: Object.assign({}, choices[0].candidate, {
        secondary: false,
        resolution: 'licensed-classics-preferred'
      }),
      alternateTargets: []
    };
  }

  function preferSpecificVintageClassicsFamily(primary, primaryCandidates, map) {
    if (
      !primary
      || primary.kind !== 'family'
      || !conceptRoutesToRoot(map, primary.target, 'root:vintage-classics')
    ) return primary;
    var phraseTokens = String(primary.phrase || '').split(' ').filter(function (token) {
      return token.length >= 4;
    }).map(function (token) {
      return token.replace(/(?:ies|s)$/i, function (suffix) {
        return suffix.toLowerCase() === 'ies'
          ? 'y'
          : '';
      });
    }).filter(Boolean);
    if (!phraseTokens.length) return primary;
    var sameSpanFamilies = primaryCandidates.filter(function (candidate) {
      return candidate.kind === 'family'
        && candidate.start === primary.start
        && candidate.end === primary.end
        && conceptRoutesToRoot(map, candidate.target, 'root:vintage-classics');
    });
    var score = function (candidate) {
      var concept = map.concepts[candidate.target] || {};
      var identity = normalizeQuery(
        String(candidate.target || '').replace(/[:_-]+/g, ' ')
        + ' ' + String(concept.l || '')
      );
      return phraseTokens.reduce(function (total, token) {
        return total + (identity.indexOf(token) !== -1 ? 1 : 0);
      }, 0);
    };
    var fullyAttestedFamilies = sameSpanFamilies.filter(function (candidate) {
      return score(candidate) === phraseTokens.length;
    });
    fullyAttestedFamilies.sort(function (left, right) {
      return score(right) - score(left) || primaryMatchOrder(left, right);
    });
    return fullyAttestedFamilies.length && score(fullyAttestedFamilies[0]) > score(primary)
      ? fullyAttestedFamilies[0]
      : primary;
  }

  function sameSpanTypeAlternative(primary, matches) {
    return Boolean(primary) && matches.some(function (match) {
      return match.kind === 'type'
        && match.start === primary.start
        && match.end === primary.end;
    });
  }

  function preferExplicitEntityForTeamTypeCollision(primary, primaryCandidates, matches) {
    if (
      !primary
      || !['team', 'franchise'].includes(primary.kind)
      || primary.protected === true
      || primary.tokens.length !== 1
      || !sameSpanTypeAlternative(primary, matches)
    ) return primary;

    var explicitEntity = primaryCandidates.filter(function (candidate) {
      return candidate.secondary !== true
        && APPAREL_CONTEXT_ENTITY_KINDS.has(candidate.kind)
        && !overlaps(candidate, primary);
    }).sort(primaryMatchOrder)[0] || null;
    return explicitEntity || primary;
  }

  function dropUnsupportedContextRequiredTeamType(primary, primaryCandidates, matches) {
    if (
      !primary
      || !['team', 'franchise'].includes(primary.kind)
      || primary.protected === true
      || primary.tokens.length !== 1
      || String(primary.resolution || '').indexOf('context-required') === -1
      || !sameSpanTypeAlternative(primary, matches)
    ) return primary;

    var hasTeamContext = primaryCandidates.some(function (candidate) {
      return GROUP_CONTEXT_KINDS.has(candidate.kind) && !overlaps(candidate, primary);
    });
    return hasTeamContext ? primary : null;
  }

  function selectModifiers(primary, matches) {
    var selected = [];
    var occupied = new Set();
    var targets = new Set();
    if (primary) {
      for (var index = primary.start; index < primary.end; index += 1) occupied.add(index);
    }
    matches.filter(function (candidate) {
      return MODIFIER_KINDS.has(candidate.kind);
    }).sort(modifierMatchOrder).forEach(function (match) {
      if (targets.has(match.target)) return;
      for (var index = match.start; index < match.end; index += 1) {
        if (occupied.has(index)) return;
      }
      selected.push(match);
      targets.add(match.target);
      for (var tokenIndex = match.start; tokenIndex < match.end; tokenIndex += 1) {
        occupied.add(tokenIndex);
      }
    });
    selected.sort(function (left, right) {
      return left.start - right.start || modifierMatchOrder(left, right);
    });
    return selected;
  }

  function availableModifierCount(primary, matches) {
    return selectModifiers(primary, matches).length;
  }

  function selectSecondaryEntities(primary, modifiers, primaryCandidates) {
    if (!primary) return [];
    var occupied = new Set();
    [primary].concat(modifiers).forEach(function (match) {
      for (var index = match.start; index < match.end; index += 1) occupied.add(index);
    });
    var selected = [];
    var targets = new Set([primary.target]);
    primaryCandidates.filter(function (candidate) {
      return !candidate.secondary && SECONDARY_ENTITY_KINDS.has(candidate.kind);
    }).sort(primaryMatchOrder).forEach(function (candidate) {
      if (selected.length >= 2 || targets.has(candidate.target)) return;
      for (var index = candidate.start; index < candidate.end; index += 1) {
        if (occupied.has(index)) return;
      }
      selected.push(candidate);
      targets.add(candidate.target);
      for (var tokenIndex = candidate.start; tokenIndex < candidate.end; tokenIndex += 1) {
        occupied.add(tokenIndex);
      }
    });
    selected.sort(function (left, right) {
      return left.start - right.start || primaryMatchOrder(left, right);
    });
    return selected;
  }

  function createResolver(map) {
    var aliasIndex = buildAliasIndex(map);
    var brandTypoRecords = buildConservativeBrandTypoRecords(map);
    var classicsTypoRecords = buildConservativeClassicsTypoRecords(map);
    return function resolve(rawQuery) {
      var normalized = normalizeQuery(rawQuery);
      var tokens = normalized ? normalized.split(' ') : [];
      var matches = collectMatches(tokens, aliasIndex);
      matches = matches.concat(collectCanonicalClassicsMatches(tokens, aliasIndex, map, matches));
      matches = matches.concat(
        collectConservativeBrandTypoMatches(tokens, brandTypoRecords, matches)
      );
      matches = matches.concat(
        collectConservativeClassicsTypoMatches(tokens, classicsTypoRecords, matches)
      );
      var primaryCandidates = matches.filter(function (match) {
        return PRIMARY_KIND_PRIORITY.has(match.kind);
      }).sort(primaryMatchOrder);
      var primary = primaryCandidates[0] || null;
      var classicsExactAlternateTargets = [];

      // A multiword context can outrank a one-word GROUP alias by length
      // ("Giants San Francisco" is the canonical case). Keep the GROUP alias
      // as the entity anchor so the context can disambiguate it below. Full
      // canonical team phrases such as "San Francisco Giants" remain primary.
      if (primary && GROUP_CONTEXT_KINDS.has(primary.kind)) {
        var groupPrimary = primaryCandidates.filter(function (candidate) {
          return !candidate.secondary
            && ['team', 'franchise'].includes(candidate.kind)
            && String(candidate.resolution || '').indexOf('multi-team-group') === 0
            && !overlaps(candidate, primary);
        }).sort(primaryMatchOrder)[0] || null;
        if (groupPrimary && !sameSpanTypeAlternative(groupPrimary, matches)) {
          primary = groupPrimary;
        }
      }

      primary = preferExplicitEntityForTeamTypeCollision(
        primary,
        primaryCandidates,
        matches
      );
      primary = dropUnsupportedContextRequiredTeamType(
        primary,
        primaryCandidates,
        matches
      );
      primary = preferSpecificVintageClassicsFamily(primary, primaryCandidates, map);

      if (primary && ['brand', 'family', 'subject', 'topic'].includes(primary.kind)) {
        var sameTargetChoices = primaryCandidates.filter(function (candidate) {
          return candidate.target === primary.target;
        });
        sameTargetChoices.sort(function (left, right) {
          return availableModifierCount(right, matches) - availableModifierCount(left, matches)
            || primaryMatchOrder(left, right);
        });
        primary = sameTargetChoices[0] || primary;
      }

      var classicsCollision = specificVintageClassicsCollision(
        primary,
        primaryCandidates,
        matches,
        map
      );
      if (classicsCollision) {
        primary = classicsCollision.primary;
        classicsExactAlternateTargets = classicsCollision.alternateTargets;
      }

      primary = preferPromotionalClassicsIdentity(primary, primaryCandidates, map);

      if (primary) {
        var overlappingContextColor = matches.some(function (match) {
          return match.kind === 'color' && overlaps(primary, match);
        });
        var outsideModifier = matches.some(function (match) {
          return MODIFIER_KINDS.has(match.kind) && !overlaps(primary, match);
        });
        if (
          primary.tokens.length === 1
          && String(primary.resolution).indexOf('context-required') === 0
          && overlappingContextColor
          && outsideModifier
        ) primary = null;
      }

      var secondCompleteTeamIdentity = primary && primaryCandidates.some(function (candidate) {
        return candidate.target !== primary.target
          && ['team', 'franchise'].includes(candidate.kind)
          && ['sports-team', 'sports-franchise'].includes(
            String(candidate.template || '').replace(/_/g, '-')
          )
          && candidate.tokens.length > 1
          && candidate.protected === true
          && !overlaps(candidate, primary);
      });
      var authoritativeTeamIdentity = Boolean(
        primary
        && ['team', 'franchise'].includes(primary.kind)
        && ['sports-team', 'sports-franchise'].includes(
          String(primary.template || '').replace(/_/g, '-')
        )
        && (
          primary.protected === true
          || primary.tokens.length > 1
          || String(primary.resolution || '').indexOf('professional-team-default') === 0
        )
        && !secondCompleteTeamIdentity
      );
      var authoritativePromotionalClassicsIdentity = Boolean(
        primary && conceptRoutesToPromotionalClassics(map, primary.target)
      );
      var modifiers = selectModifiers(primary, matches);
      var secondaryEntities = authoritativeTeamIdentity || authoritativePromotionalClassicsIdentity
        ? []
        : selectSecondaryEntities(primary, modifiers, primaryCandidates);
      var consumed = new Set();
      [primary].concat(secondaryEntities, modifiers).filter(Boolean).forEach(function (match) {
        for (var index = match.start; index < match.end; index += 1) consumed.add(index);
      });
      var filters = [];
      if (primary) filters.push(primary.target);
      secondaryEntities.forEach(function (match) { filters.push(match.target); });
      modifiers.forEach(function (match) {
        filters = filters.concat(modifierAllOf(match));
      });
      return {
        raw: String(rawQuery == null ? '' : rawQuery),
        normalized: normalized,
        filters: unique(filters),
        primary: primary,
        authoritativeTeamIdentity: authoritativeTeamIdentity,
        authoritativePromotionalClassicsIdentity: authoritativePromotionalClassicsIdentity,
        secondaryEntities: secondaryEntities,
        classicsExactAlternateTargets: classicsExactAlternateTargets,
        modifiers: modifiers,
        matches: matches,
        unconsumedTokens: tokens.filter(function (_token, index) {
          return !consumed.has(index);
        })
      };
    };
  }

  function conceptAttribute(match) {
    if (!match || !runtime || !runtime.concepts[match.target]) return null;
    var concept = runtime.concepts[match.target];
    return {
      id: match.target,
      key: match.target,
      filter: match.target,
      type: concept.k,
      kind: concept.k,
      label: concept.l,
      name: concept.l,
      count: Number(concept.n) || 0,
      terms: unique([match.phrase, concept.l])
    };
  }

  function modifierTargetClosure(target, ancestors) {
    var value = String(target || '');
    if (!value) return [];
    var visited = new Set(ancestors || []);
    invariant(!visited.has(value), 'Circular modifier dependency: ' + value);
    visited.add(value);
    var dependencies = runtime && runtime.modifier_dependencies
      && runtime.modifier_dependencies[value];
    var expanded = [];
    (Array.isArray(dependencies) ? dependencies : []).forEach(function (dependency) {
      expanded = expanded.concat(modifierTargetClosure(dependency, visited));
    });
    expanded.push(value);
    return unique(expanded);
  }

  function modifierAllOf(modifier) {
    return modifierTargetClosure(modifier && modifier.target);
  }

  function resolutionModifierTargets(resolution, kinds) {
    return unique((resolution && resolution.modifiers || []).reduce(function (targets, modifier) {
      if (kinds && !kinds.has(modifier.kind)) return targets;
      return targets.concat(modifierAllOf(modifier));
    }, []));
  }

  function rootSource(rootGroup, rawQuery) {
    if (!rootGroup) return null;
    var destination = String(rootGroup.button_collection || rootGroup.collection_url || '');
    var match = destination.match(/^\/collections\/([a-z0-9-]+)$/i);
    if (!match) return null;
    var filters = unique(rootGroup.filters || [rootGroup.filter]);
    return {
      query: String(rawQuery || '').trim() || 'Search',
      transportQuery: String(rawQuery || '').trim() || 'Search',
      label: rootGroup.label || 'Shop All',
      kind: 'domain-root-fallback',
      tier: 'broad',
      scope: 'broad',
      tierOrder: 1000,
      weight: 0,
      exact: false,
      safeExact: false,
      ctaOnly: true,
      fetchResults: false,
      domainRootFallback: true,
      collectionHandle: match[1],
      collectionUrl: destination,
      buttonCollection: destination,
      v4Filters: filters,
      sourcePlanKey: 'v4:cta:' + match[1]
    };
  }

  function rootFromRuntime(key) {
    var root = runtime.roots[key];
    if (!root) return null;
    return {
      group: 'root',
      label: root.label,
      filters: [root.filter],
      button_collection: root.collection_url
    };
  }

  function routeVariants(group) {
    var anyFilters = unique(group.any_filters || []);
    if (!anyFilters.length) return [unique(group.filters || [])];
    var anySet = new Set(anyFilters);
    var common = unique(group.filters || []).filter(function (filter) {
      return !anySet.has(filter);
    });
    return anyFilters.map(function (filter) {
      return unique(common.concat(filter));
    });
  }

  function filterCount(filters, mode) {
    var counts = filters.map(function (filter) {
      return Number(runtime.concepts[filter] && runtime.concepts[filter].n) || 0;
    }).filter(function (count) { return count > 0; });
    if (!counts.length) return 0;
    if (mode === 'any') {
      return counts.reduce(function (total, count) { return total + count; }, 0);
    }
    return Math.min.apply(Math, counts);
  }

  function sourceFor(group, filters, groupIndex, memberIndex, exact, rawQuery) {
    var values = unique(filters);
    var declaredIndexMode = group.requiredIndexMode === 'any' ? 'any' : 'all';
    invariant(
      declaredIndexMode !== 'any' || values.length <= 1,
      'Unsafe ANY source reached V4 planner: ' + values.join(' | ')
    );
    var requiredIndexTokens = values.slice();
    var requiredIndexMode = 'all';
    var v4AttestationRequired = group.v4AttestationRequired === true;
    var count = filterCount(requiredIndexTokens, requiredIndexMode);
    var clauseRole = String(group.clauseRoles && group.clauseRoles[memberIndex] || 'and-clause');
    var relationshipProofs = (group.relationshipProofs || []).map(function (proof) {
      return Object.assign({}, proof, {
        allOf: unique(proof && proof.allOf || [])
      });
    });
    var relationshipClauseProof = group.resultSectionKey === 'market-region'
      ? relationshipProofs[memberIndex] || null
      : null;
    return {
      query: String(rawQuery || '').trim() || 'Search',
      transportQuery: String(rawQuery || '').trim() || 'Search',
      label: group.label || (exact ? 'Exact matches' : 'Related matches'),
      kind: exact ? 'exact' : String(group.group || group.id || 'relationship'),
      exact: exact,
      safeExact: exact,
      tier: exact ? 'exact' : 'relationship',
      scope: exact ? 'exact' : 'core',
      tierOrder: groupIndex * 10,
      weight: 1000 - (groupIndex * 100) - memberIndex,
      relationshipGroupId: exact ? '' : 'v4:' + groupIndex + ':' + String(group.group || group.id || 'related'),
      relationshipMemberId: exact ? '' : 'v4:' + groupIndex + ':' + memberIndex,
      relationshipKind: exact ? '' : String(group.group || group.id || 'relationship'),
      entityBlockTarget: String(group.entityBlockTarget || ''),
      entityBlockIndex: Math.max(0, Number(group.entityBlockIndex) || 0),
      entityBlockPhase: String(group.entityBlockPhase || ''),
      resultSectionKey: String(group.resultSectionKey || ''),
      resultSectionLabel: String(group.resultSectionLabel || ''),
      resultSectionKind: String(group.resultSectionKind || ''),
      resultSectionOrder: Math.max(0, Number(group.resultSectionOrder) || 0),
      clauseIndex: memberIndex,
      clauseCount: group.variants.length,
      clauseRole: clauseRole,
      exactStrict: clauseRole === 'strict-exact' || clauseRole === 'exact-team',
      exactFallback: clauseRole === 'same-team-fallback',
      relationshipProductCount: count,
      v4Metafield: true,
      v4NeutralTransport: true,
      neutralTransport: true,
      trustedTransport: true,
      transportDefinesCandidateSet: !v4AttestationRequired,
      filterParameter: config.filterParameter,
      filterLogic: 'AND',
      allOf: values,
      v4Filters: values,
      v4ExcludeFilters: [EXCLUDED_FILTER],
      matchMode: requiredIndexMode,
      requiredIndexTokens: requiredIndexTokens,
      requiredIndexMode: requiredIndexMode,
      requiredIndexTokenOrder: requiredIndexTokens.slice(),
      v4HigherTierTokens: unique(group.v4HigherTierTokens || []),
      v4AttestationRequired: v4AttestationRequired,
      authoritativeTeamSource: group.authoritativeTeamSource === true,
      authoritativeClassicsSource: group.authoritativeClassicsSource === true,
      boundedTerminalSource: group.boundedTerminalSource === true,
      optionalTerminalSource: group.optionalTerminalSource === true,
      allowedHistoryTargets: unique(group.allowedHistoryTargets || []),
      allowedTeamTargets: unique(group.allowedTeamTargets || []),
      relationshipTeamOrder: unique(group.relationshipTeamOrder || []),
      relationshipProofs: relationshipProofs,
      relationshipClauseProof: relationshipClauseProof,
      ignoreRequestedAttributes: group.ignoreRequestedAttributes === true,
      preserveTransportOrder: false,
      maxSourcePages: Math.max(1, Math.min(
        24,
        Number(group.maxSourcePages) > 0
          ? Number(group.maxSourcePages)
          : Math.ceil(Math.max(1, count) / 50)
      )),
      sourcePlanKey: 'v4:' + groupIndex + ':' + memberIndex + ':' + values.join('+')
    };
  }

  function pushGroup(groups, group, variants) {
    var cleanVariants = (variants || []).map(unique).filter(function (filters) {
      return filters.length > 0;
    });
    if (!cleanVariants.length) return;
    groups.push({
      group: group.group || group.id || 'related',
      id: group.id || group.group || 'related',
      label: group.label || 'Related matches',
      entityBlockTarget: String(group.entityBlockTarget || ''),
      entityBlockIndex: Math.max(0, Number(group.entityBlockIndex) || 0),
      entityBlockPhase: String(group.entityBlockPhase || ''),
      resultSectionKey: String(group.resultSectionKey || ''),
      resultSectionLabel: String(group.resultSectionLabel || ''),
      resultSectionKind: String(group.resultSectionKind || ''),
      resultSectionOrder: Math.max(0, Number(group.resultSectionOrder) || 0),
      clauseRoles: Array.isArray(group.clauseRoles) ? group.clauseRoles.slice() : [],
      requiredIndexTokens: unique(group.requiredIndexTokens || []),
      requiredIndexMode: group.requiredIndexMode === 'any' ? 'any' : 'all',
      requiredIndexTokenOrder: unique(group.requiredIndexTokenOrder || []),
      v4HigherTierTokens: unique(group.v4HigherTierTokens || []),
      v4AttestationRequired: group.v4AttestationRequired === true,
      authoritativeTeamSource: group.authoritativeTeamSource === true,
      authoritativeClassicsSource: group.authoritativeClassicsSource === true,
      boundedTerminalSource: group.boundedTerminalSource === true,
      optionalTerminalSource: group.optionalTerminalSource === true,
      maxSourcePages: Math.max(0, Number(group.maxSourcePages) || 0),
      allowedHistoryTargets: unique(group.allowedHistoryTargets || []),
      allowedTeamTargets: unique(group.allowedTeamTargets || []),
      relationshipTeamOrder: unique(group.relationshipTeamOrder || []),
      relationshipProofs: (group.relationshipProofs || []).map(function (proof) {
        return Object.assign({}, proof, {
          allOf: unique(proof && proof.allOf || [])
        });
      }),
      ignoreRequestedAttributes: group.ignoreRequestedAttributes === true,
      variants: cleanVariants
    });
  }

  function dedupeAndLimitGroups(groups, limit) {
    var seen = new Set();
    var retained = [];
    var maximum = Math.max(1, Number(limit) || 4);
    groups.forEach(function (group) {
      var variants = group.variants.filter(function (filters) {
        var key = filters.join('|');
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });
      if (variants.length && retained.length < maximum) {
        retained.push(Object.assign({}, group, { variants: variants }));
      }
    });
    return retained;
  }

  function modifierTargets(resolution, kinds) {
    return resolutionModifierTargets(resolution, kinds);
  }

  function buildBrandGroups(resolution, concept) {
    var groups = [];
    var brand = resolution.primary.target;
    var allModifiers = resolutionModifierTargets(resolution);
    var typeModifiers = modifierTargets(resolution, new Set(['type', 'subtype']));
    var secondary = resolution.secondaryEntities.map(function (entity) {
      return entity.target;
    });
    var exactFilters = unique([brand].concat(secondary, allModifiers));
    pushGroup(groups, {
      group: 'exact',
      label: concept.l + ' exact results',
      resultSectionKey: 'brand-exact',
      resultSectionLabel: 'Brand Exact Results',
      resultSectionKind: 'brand-exact',
      resultSectionOrder: 0,
      v4AttestationRequired: true,
      ignoreRequestedAttributes: true
    }, [exactFilters]);

    // A brand route is its own closed universe. After the exact requested
    // combination, show products from that brand that do not carry the
    // requested type, followed by every remaining item from the same brand.
    // The two later tiers intentionally share the brand filter; product-index
    // attestation and v4HigherTierTokens keep them disjoint.
    if (typeModifiers.length) {
      pushGroup(groups, {
        group: 'other-brand-types',
        label: 'Other types from ' + concept.l,
        resultSectionKey: 'brand-other-types',
        resultSectionLabel: 'Other Types From This Brand',
        resultSectionKind: 'brand-other-types',
        resultSectionOrder: 10,
        v4HigherTierTokens: typeModifiers,
        v4AttestationRequired: true,
        ignoreRequestedAttributes: true
      }, [[brand]]);
    }

    if (exactFilters.join('|') !== brand) {
      pushGroup(groups, {
        group: 'all-brand-items',
        label: 'All ' + concept.l,
        resultSectionKey: 'brand-all-items',
        resultSectionLabel: 'All Items From This Brand',
        resultSectionKind: 'brand-all-items',
        resultSectionOrder: 20,
        v4AttestationRequired: true,
        ignoreRequestedAttributes: true
      }, [[brand]]);
    }
    return {
      groups: groups.slice(0, 3),
      root: rootFromRuntime('brands')
    };
  }

  function shouldInsertSameEntity(resolution, concept) {
    if (!resolution.primary || !resolution.modifiers.length) return false;
    var template = String(concept.t || '').replace(/_/g, '-');
    return template !== 'sports-team'
      && template !== 'sports-franchise'
      && template !== 'brand';
  }

  function teamRouteFilterKind(filters, fallback) {
    var values = Array.isArray(filters) ? filters : [];
    var prefixes = ['team', 'franchise', 'market', 'region', 'country', 'league', 'sport'];
    for (var index = 0; index < prefixes.length; index += 1) {
      if (values.some(function (filter) {
        return String(filter || '').indexOf(prefixes[index] + ':') === 0;
      })) return prefixes[index];
    }
    return String(fallback || 'relationship');
  }

  function orderedTeamPeers(target, kind) {
    var relationship = runtime.team_relationships
      && runtime.team_relationships[String(target || '')];
    if (!relationship) return [];
    if (!['market', 'region'].includes(kind)) return [];
    return unique((relationship.peers || []).filter(function (proof) {
      return proof && proof.active === true && proof.relationship_tier === kind;
    }).map(function (proof) {
      return proof.team;
    }));
  }

  function sharedTeamLocationQualifier(target, peerTarget, kind) {
    var relationship = runtime.team_relationships
      && runtime.team_relationships[String(target || '')];
    if (!relationship || !['market', 'region'].includes(kind)) return '';
    var proof = (relationship.peers || []).find(function (candidate) {
      return candidate
        && candidate.active === true
        && candidate.team === peerTarget
        && candidate.relationship_tier === kind;
    });
    return proof ? String(proof.qualifier || '') : '';
  }

  function executableTeamRelationshipProof(target, peerTarget, kind) {
    var qualifier = sharedTeamLocationQualifier(target, peerTarget, kind);
    if (!qualifier) return null;
    var relationship = runtime.team_relationships
      && runtime.team_relationships[String(target || '')];
    var proof = relationship && (relationship.peers || []).find(function (candidate) {
      return candidate
        && candidate.active === true
        && candidate.team === peerTarget
        && candidate.relationship_tier === kind
        && candidate.qualifier === qualifier;
    });
    if (!proof) return null;
    return {
      team: proof.team,
      relationshipTier: proof.relationship_tier,
      qualifier: proof.qualifier,
      qualifierTier: proof.qualifier_tier,
      queryable: proof.qualifier_status === 'queryable',
      routeDeclared: proof.route_declared === true,
      active: proof.active === true,
      allOf: unique(proof.clause && proof.clause.allOf || [])
    };
  }

  function multiTeamGroupForResolution(resolution) {
    if (!resolution || !resolution.primary || !runtime) return null;
    if (resolution.primary.resolution === 'product-index') return null;
    var ambiguity = runtime.ambiguities[resolution.primary.phrase];
    if (!ambiguity) return null;
    if (String(ambiguity.r || '').indexOf('multi-team-group') !== 0) return null;
    var concreteTargets = [];
    var residualTargets = [];
    unique(ambiguity.c || []).forEach(function (target) {
      var candidate = runtime.concepts[target];
      if (!candidate) return;
      if (candidate.k === 'team') concreteTargets.push(target);
      else if (candidate.k === 'franchise') residualTargets.push(target);
    });
    if (concreteTargets.length < 2) return null;
    return {
      ambiguity: ambiguity,
      concreteTargets: concreteTargets,
      residualTargets: residualTargets
    };
  }

  function conceptContextTargets(concept, target) {
    var targets = [];
    (concept && concept.r || []).forEach(function (group) {
      if (group.group === 'exact' || group.group === 'root' || group.button_collection) return;
      targets = targets.concat(group.filters || [], group.any_filters || []);
    });
    return unique(targets.concat(
      runtime.team_qualifiers && runtime.team_qualifiers[target] || []
    ));
  }

  function groupContextMatches(resolution) {
    var selected = [];
    var occupied = new Set();
    (resolution.matches || []).filter(function (match) {
      return GROUP_CONTEXT_KINDS.has(match.kind)
        && !overlaps(match, resolution.primary);
    }).sort(modifierMatchOrder).forEach(function (match) {
      for (var index = match.start; index < match.end; index += 1) {
        if (occupied.has(index)) return;
      }
      selected.push(match);
      for (var tokenIndex = match.start; tokenIndex < match.end; tokenIndex += 1) {
        occupied.add(tokenIndex);
      }
    });
    selected.sort(function (left, right) {
      return left.start - right.start || modifierMatchOrder(left, right);
    });
    return selected;
  }

  function groupContextTargets(resolution) {
    return unique(groupContextMatches(resolution).map(function (match) {
      return match.target;
    }));
  }

  function overlapsSelectedContext(match, contextMatches) {
    return (contextMatches || []).some(function (contextMatch) {
      return overlaps(match, contextMatch);
    });
  }

  function nonContextSecondaryEntities(resolution, contextMatches) {
    return (resolution.secondaryEntities || []).filter(function (entity) {
      return !GROUP_CONTEXT_KINDS.has(entity.kind)
        && !overlapsSelectedContext(entity, contextMatches);
    });
  }

  function nonContextModifiers(resolution, contextMatches) {
    return (resolution.modifiers || []).filter(function (modifier) {
      return !overlapsSelectedContext(modifier, contextMatches);
    });
  }

  function disambiguatedMultiTeamTarget(resolution, group) {
    var contextMatches = groupContextMatches(resolution);
    if (!contextMatches.length) return '';
    var contextSpans = [];
    var contextBySpan = new Map();
    contextMatches.forEach(function (match) {
      var spanKey = match.start + ':' + match.end;
      if (!contextBySpan.has(spanKey)) {
        contextBySpan.set(spanKey, []);
        contextSpans.push(spanKey);
      }
      contextBySpan.get(spanKey).push(match.target);
    });
    var candidates = group.concreteTargets.filter(function (target) {
      var available = new Set(conceptContextTargets(runtime.concepts[target], target));
      return contextSpans.every(function (spanKey) {
        return contextBySpan.get(spanKey).some(function (contextTarget) {
          return available.has(contextTarget);
        });
      });
    });
    return candidates.length === 1 ? candidates[0] : '';
  }

  function resolutionForTeamTarget(resolution, target) {
    var concept = runtime.concepts[target];
    var contextMatches = groupContextMatches(resolution);
    var secondaryEntities = nonContextSecondaryEntities(resolution, contextMatches);
    var modifiers = nonContextModifiers(resolution, contextMatches);
    var primary = Object.assign({}, resolution.primary, {
      target: target,
      kind: concept.k,
      template: concept.t
    });
    return Object.assign({}, resolution, {
      primary: primary,
      filters: unique([target].concat(
        secondaryEntities.map(function (entity) { return entity.target; }),
        resolutionModifierTargets({ modifiers: modifiers })
      )),
      secondaryEntities: secondaryEntities,
      modifiers: modifiers
    });
  }

  function buildMultiTeamGroupBlocks(resolution, group) {
    var groups = [];
    var contextMatches = groupContextMatches(resolution);
    var requestedAttributes = unique(nonContextSecondaryEntities(resolution, contextMatches).map(function (entity) {
      return entity.target;
    }).concat(resolutionModifierTargets({
      modifiers: nonContextModifiers(resolution, contextMatches)
    })));
    var blocks = [];
    group.concreteTargets.forEach(function (target, blockIndex) {
      var candidate = runtime.concepts[target];
      var label = candidate && candidate.l ? candidate.l : target;
      if (requestedAttributes.length) {
        pushGroup(groups, {
          group: 'ambiguity-entity-exact',
          id: 'ambiguity-entity-' + blockIndex + '-exact',
          label: label + ' + requested attributes',
          entityBlockTarget: target,
          entityBlockIndex: blockIndex,
          entityBlockPhase: 'exact'
        }, [[target].concat(requestedAttributes)]);
        pushGroup(groups, {
          group: 'ambiguity-entity-remainder',
          id: 'ambiguity-entity-' + blockIndex + '-remainder',
          label: label,
          entityBlockTarget: target,
          entityBlockIndex: blockIndex,
          entityBlockPhase: 'remainder'
        }, [[target]]);
      } else {
        pushGroup(groups, {
          group: 'ambiguity-entity-complete',
          id: 'ambiguity-entity-' + blockIndex + '-complete',
          label: label,
          entityBlockTarget: target,
          entityBlockIndex: blockIndex,
          entityBlockPhase: 'complete'
        }, [[target]]);
      }
      blocks.push({
        target: target,
        label: label,
        kind: 'team',
        index: blockIndex
      });
    });
    group.residualTargets.forEach(function (target, residualIndex) {
      var blockIndex = group.concreteTargets.length + residualIndex;
      var candidate = runtime.concepts[target];
      var label = candidate && candidate.l ? candidate.l : target;
      pushGroup(groups, {
        group: 'ambiguity-franchise-residual',
        id: 'ambiguity-franchise-' + residualIndex + '-residual',
        label: label,
        entityBlockTarget: target,
        entityBlockIndex: blockIndex,
        entityBlockPhase: 'residual'
      }, [[target]]);
      blocks.push({
        target: target,
        label: label,
        kind: 'franchise',
        index: blockIndex,
        residual: true
      });
    });
    return {
      groups: dedupeAndLimitGroups(groups, 30),
      root: rootFromRuntime('teamwear'),
      entityBlocks: blocks,
      unresolvedMultiTeamGroup: group.productIndex !== true
    };
  }

  function buildTeamGroups(resolution, concept) {
    var route = Array.isArray(concept.r) ? concept.r : [];
    var root = route.find(function (group) {
      return group.group === 'root' || Boolean(group.button_collection);
    }) || null;
    var primaryTarget = String(resolution.primary && resolution.primary.target || '');
    var groups = [];
    if (!primaryTarget) return { groups: groups, root: root };

    var requestedModifiers = resolutionModifierTargets(resolution);
    var strictExactAllOf = unique([primaryTarget].concat(requestedModifiers));
    var exactClauses = [strictExactAllOf];
    var exactClauseRoles = [requestedModifiers.length ? 'strict-exact' : 'exact-team'];
    if (requestedModifiers.length) {
      exactClauses.push([primaryTarget]);
      exactClauseRoles.push('same-team-fallback');
    }

    // Exact is an ordered strict-first union. The relaxed same-team clause is
    // a separately identified fallback and can only append after strict hits.
    pushGroup(groups, {
      group: 'exact',
      id: 'exact',
      label: concept.l,
      resultSectionKey: 'exact-team',
      resultSectionLabel: 'Primary Finds',
      resultSectionKind: 'exact-team',
      resultSectionOrder: 0,
      requiredIndexMode: 'all',
      clauseRoles: exactClauseRoles,
      v4AttestationRequired: true,
      authoritativeTeamSource: true,
      ignoreRequestedAttributes: false
    }, exactClauses);

    var lineages = runtime.team_lineages && runtime.team_lineages[primaryTarget] || [];
    var lineageTokens = unique(lineages.reduce(function (tokens, lineage) {
      return tokens.concat(lineage && Array.isArray(lineage.filters) ? lineage.filters : []);
    }, []).filter(function (filter) {
      return /^(?:team|franchise):/.test(String(filter || ''))
        && String(filter || '') !== primaryTarget;
    }));
    if (lineageTokens.length) {
      var historyClauses = lineageTokens.map(function (lineageTarget) {
        return unique([lineageTarget].concat(requestedModifiers));
      });
      pushGroup(groups, {
        group: 'franchise-history',
        id: 'franchise-history',
        label: 'Franchise History',
        resultSectionKey: 'franchise-history',
        resultSectionLabel: 'Franchise History',
        resultSectionKind: 'franchise-history',
        resultSectionOrder: 10,
        requiredIndexMode: 'all',
        clauseRoles: historyClauses.map(function () { return 'franchise-history'; }),
        v4HigherTierTokens: [primaryTarget],
        v4AttestationRequired: true,
        authoritativeTeamSource: true,
        allowedHistoryTargets: lineageTokens,
        ignoreRequestedAttributes: false
      }, historyClauses);
    }

    var relationshipProofs = [];
    ['market', 'region'].forEach(function (kind) {
      orderedTeamPeers(primaryTarget, kind).forEach(function (peerTarget) {
        var proof = executableTeamRelationshipProof(primaryTarget, peerTarget, kind);
        if (proof) relationshipProofs.push(proof);
      });
    });
    var relationshipTeamOrder = unique(relationshipProofs.map(function (proof) {
      return proof.team;
    }));

    if (relationshipProofs.length) {
      var geographyClauses = relationshipProofs.map(function (proof) {
        return proof.allOf.slice();
      });
      pushGroup(groups, {
        group: 'market-region',
        id: 'market-region',
        label: 'Market / Region',
        resultSectionKey: 'market-region',
        resultSectionLabel: 'Extended Finds',
        resultSectionKind: 'market-region',
        resultSectionOrder: 20,
        requiredIndexMode: 'all',
        clauseRoles: relationshipProofs.map(function (proof) {
          return proof.relationshipTier + '-peer';
        }),
        v4HigherTierTokens: [primaryTarget].concat(lineageTokens),
        v4AttestationRequired: true,
        authoritativeTeamSource: true,
        allowedTeamTargets: relationshipTeamOrder,
        relationshipTeamOrder: relationshipTeamOrder,
        relationshipProofs: relationshipProofs,
        ignoreRequestedAttributes: false
      }, geographyClauses);
    }
    return {
      groups: dedupeAndLimitGroups(groups, 3),
      root: root
    };
  }

  function buildMappedGroups(resolution, concept) {
    var route = Array.isArray(concept.r) ? concept.r : [];
    var principal = route.filter(function (group) {
      return group.group !== 'root' && !group.button_collection;
    });
    var root = route.find(function (group) {
      return group.group === 'root' || Boolean(group.button_collection);
    }) || null;
    var groups = [];
    var template = String(concept.t || '').replace(/_/g, '-');
    var vintageClassicsRoute = resolution.primary
      && conceptRoutesToRoot(runtime, resolution.primary.target, 'root:vintage-classics');
    var shorthandTeamRoute = Boolean(
      resolution.primary
      && ['team', 'franchise'].includes(resolution.primary.kind)
      && ['sports-team', 'sports-franchise'].includes(template)
    );
    var exactRoute = principal[0] || { group: 'exact', label: concept.l };
    var exactGroup = {
      group: 'exact',
      label: exactRoute.label || concept.l
    };
    if (vintageClassicsRoute) {
      exactGroup.resultSectionKey = 'classics-primary';
      exactGroup.resultSectionLabel = 'Primary Finds';
      exactGroup.resultSectionKind = 'classics-primary';
      exactGroup.resultSectionOrder = 0;
      exactGroup.v4AttestationRequired = true;
      exactGroup.authoritativeClassicsSource = true;
    }
    if (shorthandTeamRoute) {
      exactGroup.resultSectionKey = 'exact-team';
      exactGroup.resultSectionLabel = 'Primary Finds';
      exactGroup.resultSectionKind = 'exact-team';
      exactGroup.resultSectionOrder = 0;
      exactGroup.v4AttestationRequired = true;
    }
    var exactModifiers = resolutionModifierTargets(resolution);
    var exactSecondaryTargets = resolution.secondaryEntities.map(function (entity) {
      return entity.target;
    });
    var exactVariants = vintageClassicsRoute
      ? routeVariants(exactRoute).map(function (filters) {
        return unique(filters.concat(exactSecondaryTargets, exactModifiers));
      })
      : [resolution.filters];
    (resolution.classicsExactAlternateTargets || []).forEach(function (target) {
      if (vintageClassicsRoute) {
        routeVariants(exactRoute).forEach(function (filters) {
          exactVariants.push(unique(filters.map(function (filter) {
            return filter === resolution.primary.target ? target : filter;
          }).concat(exactSecondaryTargets, exactModifiers)));
        });
      } else {
        exactVariants.push(unique([target].concat(exactSecondaryTargets, exactModifiers)));
      }
    });
    pushGroup(groups, exactGroup, exactVariants);

    if (shorthandTeamRoute && resolution.modifiers.length) {
      pushGroup(groups, {
        group: 'same-team-fallback',
        label: concept.l,
        resultSectionKey: 'exact-team',
        resultSectionLabel: 'Primary Finds',
        resultSectionKind: 'exact-team',
        resultSectionOrder: 0,
        v4AttestationRequired: true,
        ignoreRequestedAttributes: true
      }, [[resolution.primary.target]]);
    } else if (shouldInsertSameEntity(resolution, concept)) {
      var sameEntity = vintageClassicsRoute
        ? [resolution.primary.target]
        : unique([resolution.primary.target].concat(
          resolution.secondaryEntities.map(function (entity) { return entity.target; })
        ));
      var sameEntityGroup = {
        group: 'same-entity',
        label: concept.l
      };
      if (vintageClassicsRoute) {
        sameEntityGroup.resultSectionKey = 'classics-primary';
        sameEntityGroup.resultSectionLabel = 'Primary Finds';
        sameEntityGroup.resultSectionKind = 'classics-primary';
        sameEntityGroup.resultSectionOrder = 0;
        sameEntityGroup.v4AttestationRequired = true;
        sameEntityGroup.authoritativeClassicsSource = true;
      }
      var sameEntityVariants = vintageClassicsRoute
        ? routeVariants(exactRoute).map(function (filters) {
          return unique(filters.concat(exactSecondaryTargets));
        })
        : [sameEntity];
      (resolution.classicsExactAlternateTargets || []).forEach(function (target) {
        if (vintageClassicsRoute) {
          routeVariants(exactRoute).forEach(function (filters) {
            sameEntityVariants.push(unique(filters.map(function (filter) {
              return filter === resolution.primary.target ? target : filter;
            }).concat(exactSecondaryTargets)));
          });
        } else {
          sameEntityVariants.push([target]);
        }
      });
      pushGroup(groups, sameEntityGroup, sameEntityVariants);
    }

    var relationshipGroups = vintageClassicsRoute
      ? principal.slice(1, 2)
      : principal.slice(1);
    relationshipGroups.forEach(function (group) {
      var mappedGroup = group;
      if (shorthandTeamRoute) {
        mappedGroup = Object.assign({}, group, {
          resultSectionKey: 'market-region',
          resultSectionLabel: 'Extended Finds',
          resultSectionKind: 'market-region',
          resultSectionOrder: 20,
          v4AttestationRequired: true,
          ignoreRequestedAttributes: true
        });
      } else if (vintageClassicsRoute) {
        mappedGroup = Object.assign({}, group, {
          resultSectionKey: 'classics-extended',
          resultSectionLabel: 'Extended Finds',
          resultSectionKind: 'classics-extended',
          resultSectionOrder: 20,
          v4AttestationRequired: true,
          authoritativeClassicsSource: true,
          boundedTerminalSource: true,
          maxSourcePages: 2,
          ignoreRequestedAttributes: true
        });
      }
      pushGroup(groups, mappedGroup, routeVariants(group));
    });
    return {
      groups: dedupeAndLimitGroups(
        groups,
        vintageClassicsRoute ? Math.max(4, groups.length) : 4
      ),
      root: root
    };
  }

  function quotedShopifyTitleClause(value) {
    var phrase = String(value || '').trim();
    if (!phrase) return '';
    return 'title:"' + phrase.replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"';
  }

  function vintageClassicsCrossRootTitleEligible(resolution, concept) {
    if (
      !resolution.primary
      || !['subject', 'person', 'event'].includes(resolution.primary.kind)
    ) return false;
    var relationshipTokens = unique((concept.r || []).reduce(function (tokens, group) {
      if (!group || group.group === 'exact' || group.group === 'root') return tokens;
      return tokens.concat(group.filters || [], group.any_filters || []);
    }, []));
    return relationshipTokens.length > 0
      && !relationshipTokens.includes('family:animals');
  }

  function vintageClassicsTitleRescueSource(resolution, concept, rawQuery) {
    if (
      !resolution.primary
      || resolution.primary.resolution === 'product-index'
      || !['subject', 'topic', 'person', 'event'].includes(resolution.primary.kind)
      || String(concept.t || '').replace(/_/g, '-') !== 'vintage-subject'
      || !conceptRoutesToRoot(runtime, resolution.primary.target, 'root:vintage-classics')
      || resolution.secondaryEntities.length > 0
    ) return null;
    var terms = unique([concept.l, resolution.primary.phrase]);
    var clauses = unique(terms.map(quotedShopifyTitleClause));
    if (!clauses.length) return null;
    var allowCrossRootTitleRescue = vintageClassicsCrossRootTitleEligible(resolution, concept);
    var requiredIndexIdentity = ['subject', 'person', 'event'].includes(resolution.primary.kind)
      ? resolution.primary.target
      : '';
    return {
      query: String(rawQuery || '').trim() || concept.l,
      transportQuery: clauses.length > 1 ? '(' + clauses.join(' OR ') + ')' : clauses[0],
      label: concept.l,
      kind: 'classics-title-rescue',
      exact: false,
      safeExact: false,
      tier: 'relationship',
      scope: 'core',
      tierOrder: 90,
      weight: 950,
      relationshipGroupId: 'v4:classics-title-rescue',
      relationshipMemberId: 'v4:classics-title-rescue:0',
      relationshipKind: 'classics-title-rescue',
      resultSectionKey: 'classics-primary',
      resultSectionLabel: 'Primary Finds',
      resultSectionKind: 'classics-primary',
      resultSectionOrder: 0,
      classicsTitleRescue: true,
      requiredIndexRoot: 'root:vintage-classics',
      allowCrossRootTitleRescue: allowCrossRootTitleRescue,
      requiredIndexIdentity: requiredIndexIdentity,
      requiredIndexIdentityPrefix: requiredIndexIdentity
        ? resolution.primary.kind + ':'
        : '',
      matchTerms: terms,
      matchMode: 'any',
      trustedTransport: false,
      transportDefinesCandidateSet: false,
      ignoreRequestedAttributes: false,
      optionalTerminalSource: true,
      maxSourcePages: 2,
      sourcePlanKey: 'v4:classics-title-rescue:' + resolution.primary.target
    };
  }

  function leagueForConcept(concept) {
    var leagueFilter = null;
    (concept.r || []).some(function (group) {
      return (group.filters || []).some(function (filter) {
        if (String(filter).indexOf('league:') === 0) {
          leagueFilter = filter;
          return true;
        }
        return false;
      });
    });
    if (!leagueFilter) {
      var target = Object.keys(runtime.concepts || {}).find(function (candidateTarget) {
        return runtime.concepts[candidateTarget] === concept;
      });
      leagueFilter = (runtime.team_qualifiers && runtime.team_qualifiers[target] || []).find(function (filter) {
        return String(filter).indexOf('league:') === 0;
      }) || null;
    }
    return leagueFilter && runtime.concepts[leagueFilter]
      ? runtime.concepts[leagueFilter].l
      : '';
  }

  function buildAnalysis(rawQuery, resolution) {
    if (!resolution.filters.length) return nativeFallback(rawQuery, 'unrecognized');
    var anchor = resolution.primary || resolution.modifiers[0];
    var concept = runtime.concepts[anchor.target];
    if (!concept) return nativeFallback(rawQuery, 'unrecognized');
    var productIndexMultiTeamGroup = resolution.productIndexMultiTeam
      && Array.isArray(resolution.productIndexTeamTargets)
      && resolution.productIndexTeamTargets.length > 1
      ? {
        concreteTargets: resolution.productIndexTeamTargets.slice(),
        residualTargets: [],
        productIndex: true
      }
      : null;
    var multiTeamGroup = productIndexMultiTeamGroup || multiTeamGroupForResolution(resolution);
    var disambiguatedTarget = multiTeamGroup && !productIndexMultiTeamGroup
      ? disambiguatedMultiTeamTarget(resolution, multiTeamGroup)
      : '';
    if (disambiguatedTarget) {
      resolution = resolutionForTeamTarget(resolution, disambiguatedTarget);
      concept = runtime.concepts[disambiguatedTarget];
      multiTeamGroup = null;
    }
    var template = String(concept.t || '').replace(/_/g, '-');
    var authoritativeTeamRoute = Boolean(
      !multiTeamGroup
      && resolution.authoritativeTeamIdentity === true
      && resolution.primary
      && ['team', 'franchise'].includes(resolution.primary.kind)
      && ['sports-team', 'sports-franchise'].includes(template)
    );
    var resolvedCanadaTokens = unique(
      resolution.filters.concat(
        resolution.modifiers.reduce(function (tokens, modifier) {
          return tokens.concat(modifierAllOf(modifier));
        }, [])
      )
    );
    var canadianGeographyTokens = new Set();
    Object.keys(runtime.team_qualifiers || {}).forEach(function (target) {
      var qualifiers = runtime.team_qualifiers[target] || [];
      if (qualifiers.indexOf('country:canada') === -1) return;
      qualifiers.forEach(function (token) {
        if (/^(?:country|location|market|region):/.test(String(token || ''))) {
          canadianGeographyTokens.add(String(token).trim().toLowerCase());
        }
      });
    });
    var canadaCtaEligible = resolvedCanadaTokens.some(function (token) {
      var normalizedToken = String(token || '').trim().toLowerCase();
      return canadianGeographyTokens.has(normalizedToken) || [
        'country:canada',
        'location:canada',
        'family:canada',
        'collection:canada-vintage'
      ].includes(normalizedToken);
    });
    if (
      !canadaCtaEligible
      && !multiTeamGroup
      && resolution.primary
      && ['team', 'franchise'].includes(resolution.primary.kind)
    ) {
      canadaCtaEligible = (runtime.team_qualifiers[resolution.primary.target] || [])
        .some(function (token) {
          return String(token || '').trim().toLowerCase() === 'country:canada';
        });
    }
    var planned = multiTeamGroup
      ? buildMultiTeamGroupBlocks(resolution, multiTeamGroup)
      : (
        resolution.primary && resolution.primary.kind === 'brand'
          ? buildBrandGroups(resolution, concept)
          : (
            resolution.primary
            && authoritativeTeamRoute
              ? buildTeamGroups(resolution, concept)
              : buildMappedGroups(resolution, concept)
          )
      );
    if (!planned.groups.length) return nativeFallback(rawQuery, 'unrecognized');

    var exactSources = [];
    var broadSources = [];
    planned.groups.forEach(function (group, groupIndex) {
      group.variants.forEach(function (filters, memberIndex) {
        var source = sourceFor(group, filters, groupIndex, memberIndex, groupIndex === 0, rawQuery);
        if (groupIndex === 0) exactSources.push(source);
        else broadSources.push(source);
      });
    });
    var classicsTitleRescue = vintageClassicsTitleRescueSource(
      resolution,
      concept,
      rawQuery
    );
    if (classicsTitleRescue) broadSources.push(classicsTitleRescue);
    var cta = rootSource(planned.root, rawQuery);
    var entity = resolution.primary ? conceptAttribute(resolution.primary) : null;
    var secondaryEntities = resolution.secondaryEntities.map(conceptAttribute).filter(Boolean);
    var modifierAttributes = resolution.modifiers.map(conceptAttribute).filter(Boolean);
    var types = modifierAttributes.filter(function (attribute) {
      return attribute.kind === 'type' || attribute.kind === 'subtype';
    });
    var sizes = modifierAttributes.filter(function (attribute) {
      return attribute.kind === 'size';
    });
    var colors = modifierAttributes.filter(function (attribute) {
      return attribute.kind === 'color';
    });
    var decades = modifierAttributes.filter(function (attribute) {
      return attribute.kind === 'era' || attribute.kind === 'year';
    });
    var ambiguity = resolution.primary
      ? runtime.ambiguities[resolution.primary.phrase]
      : null;
    var subject = entity ? Object.assign({}, entity, {
      league: ['team', 'franchise'].includes(entity.kind) ? leagueForConcept(concept) : ''
    }) : null;
    var brands = [entity].concat(secondaryEntities).filter(function (attribute) {
      return attribute && attribute.kind === 'brand';
    });
    var themes = [];
    if (subject && subject.league) {
      themes.push({
        id: 'league:' + normalizeQuery(subject.league).replace(/\s+/g, '-'),
        key: 'league:' + normalizeQuery(subject.league).replace(/\s+/g, '-'),
        label: subject.league,
        name: subject.league
      });
    }
    var exactEstimate = estimateIntersection(resolution.filters);
    return {
      version: RUNTIME_VERSION,
      runtimeVersion: RUNTIME_VERSION,
      rawQuery: String(rawQuery == null ? '' : rawQuery),
      normalizedQuery: resolution.normalized,
      databaseReady: true,
      complete: true,
      recognized: true,
      nativeFallback: false,
      recognizedFailClosed: true,
      authoritativeTeamRoute: authoritativeTeamRoute,
      canadaCtaEligible: canadaCtaEligible,
      authoritativeTeamTarget: authoritativeTeamRoute && resolution.primary
        ? resolution.primary.target
        : '',
      fallbackQuery: String(rawQuery == null ? '' : rawQuery),
      matchedAlias: resolution.primary ? resolution.primary.phrase : '',
      protectedAlias: Boolean(resolution.primary && resolution.primary.protected),
      ambiguous: Boolean(ambiguity && (ambiguity.c || []).length > 1),
      ambiguity: ambiguity || null,
      unresolvedMultiTeamGroup: planned.unresolvedMultiTeamGroup === true,
      ambiguityGroupTargets: (planned.entityBlocks || []).map(function (block) {
        return block.target;
      }),
      entityBlocks: (planned.entityBlocks || []).map(function (block) {
        return Object.assign({}, block);
      }),
      resolvedBareProfessionalCollision: Boolean(
        resolution.primary
        && String(resolution.primary.resolution).indexOf('professional-team-default') === 0
      ),
      routeTemplate: String(concept.t || '').replace(/_/g, '-'),
      resolvedFilters: resolution.filters.slice(),
      unconsumedTokens: resolution.unconsumedTokens.slice(),
      primary: resolution.primary ? {
        phrase: resolution.primary.phrase,
        target: resolution.primary.target,
        kind: resolution.primary.kind,
        template: resolution.primary.template,
        protected: resolution.primary.protected
      } : null,
      modifiers: resolution.modifiers.map(function (modifier) {
        return {
          phrase: modifier.phrase,
          target: modifier.target,
          kind: modifier.kind,
          allOf: modifierAllOf(modifier)
        };
      }),
      secondaryEntities: secondaryEntities,
      classicsTitleRescue: Boolean(classicsTitleRescue),
      entity: entity,
      entityType: entity ? entity.kind : '',
      subject: subject,
      team: entity && ['team', 'franchise'].includes(entity.kind) ? entity : null,
      brands: brands,
      themes: themes,
      types: types,
      sizes: sizes,
      colors: colors,
      decades: decades,
      estimatedExactCount: exactEstimate,
      exactSources: exactSources,
      broadSources: broadSources,
      searches: cta ? [cta] : [],
      rootCta: cta
    };
  }

  function estimateIntersection(filters) {
    var catalogCount = Number(runtime.concepts['version:v4-11'] && runtime.concepts['version:v4-11'].n) || 6504;
    var counts = (filters || []).map(function (filter) {
      return Number(runtime.concepts[filter] && runtime.concepts[filter].n) || 0;
    }).filter(function (count) { return count > 0; });
    if (!counts.length) return 0;
    counts.sort(function (left, right) { return left - right; });
    var estimate = counts[0];
    for (var index = 1; index < counts.length; index += 1) {
      estimate *= Math.min(1, Math.max(0.08, counts[index] / catalogCount));
    }
    return Math.max(1, Math.round(estimate));
  }

  function nativeFallback(rawQuery, reason) {
    return {
      version: RUNTIME_VERSION,
      runtimeVersion: RUNTIME_VERSION,
      rawQuery: String(rawQuery == null ? '' : rawQuery),
      normalizedQuery: normalizeQuery(rawQuery),
      fallbackQuery: String(rawQuery == null ? '' : rawQuery),
      databaseReady: runtime !== null,
      complete: true,
      recognized: false,
      nativeFallback: true,
      fallbackReason: reason || 'unrecognized',
      exactSources: [],
      broadSources: [],
      searches: [],
      resolvedFilters: [],
      modifiers: [],
      secondaryEntities: []
    };
  }

  function analyzeSearch(rawQuery) {
    if (!runtime || !resolver) {
      return nativeFallback(rawQuery, runtimeFailure ? 'map-unavailable' : 'map-pending');
    }
    return buildAnalysis(rawQuery, resolver(rawQuery));
  }

  function analyzeSearchAsync(rawQuery) {
    return loadRuntime().then(function () {
      return analyzeSearch(rawQuery);
    }).catch(function () {
      return nativeFallback(rawQuery, 'map-unavailable');
    });
  }

  function productIndexValues(input) {
    var source = Array.isArray(input) ? input : [input];
    return unique(source.reduce(function (values, value) {
      if (Array.isArray(value)) return values.concat(productIndexValues(value));
      var text = String(value == null ? '' : value).trim();
      if (text.charAt(0) === '[') {
        try {
          var nested = JSON.parse(text);
          if (Array.isArray(nested)) return values.concat(productIndexValues(nested));
        } catch (_error) {}
      }
      return values.concat(text.split(';'));
    }, []).map(function (value) {
      return String(value || '').trim().toLowerCase();
    }));
  }

  function productIndexMatch(target, index) {
    var concept = runtime && runtime.concepts[target];
    if (!concept) return null;
    var phrase = normalizeQuery(concept.l || target) || normalizeQuery(target);
    var tokens = phrase ? phrase.split(' ') : [];
    return {
      phrase: phrase,
      target: target,
      kind: concept.k,
      template: concept.t,
      protected: false,
      resolution: 'product-index',
      secondary: false,
      priority: PRODUCT_PRIMARY_KIND_PRIORITY.get(concept.k) || 0,
      tokens: tokens,
      start: index,
      end: index + Math.max(1, tokens.length)
    };
  }

  function resolutionFromProductIndex(input, fallbackQuery) {
    if (!runtime) return null;
    var indexValues = productIndexValues(input);
    var hasVintageClassicsRoot = indexValues.indexOf('root:vintage-classics') !== -1;
    var hasBrand = indexValues.some(function (target) {
      return String(target).indexOf('brand:') === 0;
    });
    var matches = indexValues.map(function (target, index) {
      return productIndexMatch(target, index);
    }).filter(Boolean);
    var primary = matches.filter(function (match) {
      return PRODUCT_PRIMARY_KIND_PRIORITY.has(match.kind);
    }).sort(function (left, right) {
      var leftPriority = PRODUCT_PRIMARY_KIND_PRIORITY.get(left.kind) || 0;
      var rightPriority = PRODUCT_PRIMARY_KIND_PRIORITY.get(right.kind) || 0;
      // Descriptor topics such as "lightweight jacket" must not displace Adidas
      // on a Brands-only item. Within Vintage Classics, however, the curated
      // family/topic taxonomy is intentionally more useful than the maker.
      if (hasBrand && !hasVintageClassicsRoot && ['family', 'topic'].includes(left.kind)) {
        leftPriority = 80;
      }
      if (hasBrand && !hasVintageClassicsRoot && ['family', 'topic'].includes(right.kind)) {
        rightPriority = 80;
      }
      return rightPriority - leftPriority
        || left.start - right.start
        || left.target.localeCompare(right.target);
    })[0] || null;
    if (!primary) return null;
    var productIndexTeamTargets = unique(matches.filter(function (match) {
      return match.kind === 'team';
    }).map(function (match) {
      return match.target;
    }));

    // Product recommendations use the indexed entity as their anchor and only
    // retain garment type as a requested attribute. Size, colour, era and
    // feature values describe the current one-off item; carrying all of them
    // forward would usually make the exact tier contain only that same product.
    var modifiers = matches.filter(function (match) {
      return PRODUCT_CONTEXT_MODIFIER_KINDS.has(match.kind);
    }).sort(function (left, right) {
      return left.start - right.start || left.target.localeCompare(right.target);
    });
    var filters = unique([primary.target].concat(modifiers.map(function (modifier) {
      return modifier.target;
    })));
    return {
      raw: String(fallbackQuery == null ? '' : fallbackQuery),
      normalized: normalizeQuery(fallbackQuery),
      filters: filters,
      primary: primary,
      authoritativeTeamIdentity: ['team', 'franchise'].includes(primary.kind)
        && productIndexTeamTargets.length <= 1,
      secondaryEntities: [],
      modifiers: modifiers,
      matches: matches,
      productIndexTeamTargets: productIndexTeamTargets,
      productIndexMultiTeam: productIndexTeamTargets.length > 1,
      unconsumedTokens: []
    };
  }

  function analyzeProductIndex(input, fallbackQuery) {
    if (!runtime) {
      return nativeFallback(fallbackQuery, runtimeFailure ? 'map-unavailable' : 'map-pending');
    }
    var resolution = resolutionFromProductIndex(input, fallbackQuery);
    return resolution
      ? buildAnalysis(fallbackQuery || (resolution.primary && resolution.primary.phrase) || '', resolution)
      : nativeFallback(fallbackQuery, 'product-index-unrecognized');
  }

  function analyzeProductIndexAsync(input, fallbackQuery) {
    return loadRuntime().then(function () {
      return analyzeProductIndex(input, fallbackQuery);
    }).catch(function () {
      return nativeFallback(fallbackQuery, 'map-unavailable');
    });
  }

  function phraseInText(text, phrase) {
    var haystack = normalizeQuery(text);
    var needle = normalizeQuery(phrase);
    if (!haystack || !needle) return false;
    return (' ' + haystack + ' ').indexOf(' ' + needle + ' ') !== -1;
  }

  function productHaystack(product) {
    return [
      product && product.title,
      product && product.vendor,
      product && (product.product_type || product.type),
      product && product.size,
      product && product.sizes,
      product && product.colors,
      product && product.year,
      product && product.handle,
      product && product.tags
    ].filter(Boolean).join(' ');
  }

  function productScore(product, analysis, source) {
    var haystack = productHaystack(product);
    var score = source && source.exact ? 10000 : 5000;
    score -= Math.max(0, Number(source && source.tierOrder) || 0) * 10;
    var entityTerms = [
      analysis && analysis.entity && analysis.entity.label,
      analysis && analysis.matchedAlias
    ].filter(Boolean);
    entityTerms.forEach(function (term) {
      if (phraseInText(haystack, term)) score += 240;
    });
    (analysis && analysis.modifiers || []).forEach(function (modifier) {
      var attribute = runtime && runtime.concepts[modifier.target];
      if (phraseInText(haystack, modifier.phrase) || (attribute && phraseInText(haystack, attribute.l))) {
        score += 80;
      }
    });
    if (analysis && phraseInText(haystack, analysis.rawQuery)) score += 300;
    if (product && product.available !== false) score += 5;
    return score;
  }

  function estimateCloseMatches(analysis, broadTotal) {
    var total = Math.max(0, Number(broadTotal) || 0);
    var estimate = Math.max(0, Number(analysis && analysis.estimatedExactCount) || 0);
    return {
      count: total > 0 ? Math.min(total, estimate) : estimate,
      estimated: true
    };
  }

  var api = Object.freeze({
    version: RUNTIME_VERSION,
    analyzeSearchAsync: analyzeSearchAsync,
    analyzeSearch: analyzeSearch,
    analyzeProductIndexAsync: analyzeProductIndexAsync,
    analyzeProductIndex: analyzeProductIndex,
    productScore: productScore,
    phraseInText: phraseInText,
    estimateCloseMatches: estimateCloseMatches
  });
  window.VCCSearchV4 = api;

  try {
    document.dispatchEvent(new CustomEvent('vcc:search-v4-ready', {
      detail: { version: RUNTIME_VERSION }
    }));
  } catch (_error) {
    try {
      document.dispatchEvent(new Event('vcc:search-v4-ready'));
    } catch (_eventError) {}
  }

  updateSearchBuildMarker();
  loadRuntime().catch(function () {});
})();
